/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  
  // Initialisiere globale Variablen
  window.isRemovingFreeItems = false;
  window.isProcessingGifts = false;
  window.lastCartItemCount = 0;
  window.lastPaidItemCount = 0;
  window.manuallyRemovedGifts = []; // Array zum Speichern von manuell entfernten Gratisprodukten als {productId, giftBlockId}
  
  // Globale Referenz auf die dsCartDrawer-Instanz
  window.dsCartDrawerInstance = null;
  
  // Prüfen, ob der Parameter open_cart=1 in der URL vorhanden ist
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('open_cart') === '1') {
      // Cart-Drawer öffnen
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('open-cart', {'detail': {open: true}}));
      }, 500); // Kurze Verzögerung, um sicherzustellen, dass die Seite vollständig geladen ist
    }
  });
  
  // Speichere den ursprünglichen Text des Checkout-Buttons
  let originalCheckoutButtonText = '';
  
  // Funktion zum Aktualisieren des Checkout-Button-Status
  function updateCheckoutButtonState() {
    const isProcessing = window.isRemovingFreeItems || window.isProcessingGifts;
    const checkoutButton = document.querySelector('.ds-checkout-button');
    
    // Debug info entfernt
    
    if (!checkoutButton) {
      return;
    }
    
    // Speichere den ursprünglichen Text beim ersten Aufruf
    if (!originalCheckoutButtonText && checkoutButton.textContent) {
      originalCheckoutButtonText = checkoutButton.textContent.trim();
      // Debug info entfernt
    }
    
    if (isProcessing) {
      // Button optisch als deaktiviert kennzeichnen
      // Debug info entfernt
      checkoutButton.classList.add('opacity-50', 'cursor-not-allowed');
      checkoutButton.style.opacity = '0.5';
      checkoutButton.style.cursor = 'not-allowed';
      checkoutButton.textContent = 'Verarbeite Geschenke...';
      checkoutButton.disabled = true;
    } else {
      // Button-Status zurücksetzen
      // Debug info entfernt
      checkoutButton.classList.remove('opacity-50', 'cursor-not-allowed');
      checkoutButton.style.opacity = '';
      checkoutButton.style.cursor = '';
      // Verwende den ursprünglichen Text oder einen Fallback
      checkoutButton.textContent = originalCheckoutButtonText || 'Zur Kasse';
      checkoutButton.disabled = false;
    }
  }
  
  // Periodisch den Button-Status aktualisieren, um sicherzustellen, dass er nicht hängen bleibt
  setInterval(function() {
    // Prüfe, ob die Flags korrekt sind
    if (window.isRemovingFreeItems && !document.querySelector('.ds-checkout-button[disabled]')) {
      updateCheckoutButtonState();
    } else if (!window.isRemovingFreeItems && !window.isProcessingGifts && 
               document.querySelector('.ds-checkout-button[disabled]')) {
      // Setze die Flags explizit zurück, falls sie irgendwo hängen geblieben sind
      window.isRemovingFreeItems = false;
      window.isProcessingGifts = false;
      updateCheckoutButtonState();
    }
  }, 1000); // Überprüfe jede Sekunde
  
  // Direktes Setzen der Variablen, um Property-Descriptor-Probleme zu vermeiden
  window._setGiftProcessingState = function(isRemovingItems, isProcessingGifts) {
    // Debug info entfernt
    window.isRemovingFreeItems = isRemovingItems;
    window.isProcessingGifts = isProcessingGifts;
    updateCheckoutButtonState();
  };
  
  // Initialisiere den Button-Status beim Laden der Seite
  document.addEventListener('DOMContentLoaded', function() {
    // Debug info entfernt
    updateCheckoutButtonState();
  });

  // Function to open the cart drawer automatically when a product is added to the cart
  document.addEventListener("DOMContentLoaded", function () {
    // Initialisiere den Warenkorb-Zähler beim Laden der Seite
    // Hole die aktuelle Anzahl der Artikel im Warenkorb über die fetch API
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCountInHeader(cart.item_count);
      })
      .catch(error => {
        // Error fetching cart
        // Fallback: Verstecke alle Warenkorb-Zähler im Fehlerfall
        updateCartCountInHeader(0);
      });
    
    // Listen for the CartJS 'cart.requestComplete' event
    jQuery(document).on("cart.requestComplete", function (event, cart) {
      // Dispatch cart-update event first to update the cart data
      window.dispatchEvent(
        new CustomEvent("cart-update", { detail: { cart: cart } })
      );

      // Then wait a short moment to ensure the cart data is updated before opening
      setTimeout(() => {
        // Dispatch the open-cart event to open the cart drawer
        window.dispatchEvent(
          new CustomEvent("open-cart", { detail: { open: true } })
        );
      }, 300);
    });

    // Also handle the ajaxCart function if it's called directly
    window.ajaxCart =
      window.ajaxCart ||
      async function (event) {
        event.preventDefault();

        // If there's an existing ajaxCart function, call it first
        if (window._originalAjaxCart) {
          await window._originalAjaxCart(event);
        } else {
          // Get the variant ID from the clicked button
          const button = event.currentTarget;
          const variantId = button.getAttribute("data-variant-atc-id");

          if (variantId) {
            // Show loading state
            window.dispatchEvent(new CustomEvent("cart-loading", {}));

            // Add the item to the cart
            try {
              const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                    },
                  ],
                }),
              });

              if (response.ok) {
                // Get updated cart data
                const cartResponse = await fetch("/cart.js");
                const cart = await cartResponse.json();

                // Update cart data first
                window.dispatchEvent(
                  new CustomEvent("cart-update", { detail: { cart: cart } })
                );

                // Then open the cart drawer after a short delay
                setTimeout(() => {
                  window.dispatchEvent(
                    new CustomEvent("open-cart", { detail: { open: true } })
                  );
                }, 300);
              }
            } catch (error) {
              // Error adding product to cart
            }
          }
        }
      };

    // Store the original ajaxCart function if it exists
    if (window.ajaxCart && window.ajaxCart !== window.ajaxCart) {
      window._originalAjaxCart = window.ajaxCart;
    }
  });

  // Haelt den Warenkorb-Zaehler im Header aktuell.
  // Der Warenkorb-Zustand selbst wird NICHT hier aktualisiert, sondern von der
  // Alpine-Komponente des Drawers: @cart-update.window="updateCart(...)" in
  // sections/digitalsprung-cart-drawer.liquid. Hier steht nur, was ausserhalb
  // des Alpine-Scopes liegt.
  window.addEventListener("cart-update", function (event) {
    const cart = event.detail.cart;

    updateCartCountInHeader(cart.item_count);
  });
  
  // Function to update the cart count in the header
  function updateCartCountInHeader(count) {
    // Stelle sicher, dass count eine Zahl ist
    count = parseInt(count) || 0;
    // Update all cart count elements with various selectors that might be used in the theme
    const selectors = [
      '[data-js-cart-count-js]',
      '[data-js-cart-count]',
      '.cart-count-js',
      '.cart-count',
      '.header__cart-count'
    ];
    
    // Kombiniere alle Selektoren für eine einzige Abfrage
    const combinedSelector = selectors.join(', ');
    
    // Aktualisiere alle passenden Elemente
    document.querySelectorAll(combinedSelector).forEach(element => {
      // Wenn der Warenkorb leer ist, keine Zahl anzeigen, sonst die Anzahl
      element.textContent = count > 0 ? count : '';
    });
    
    // Aktualisiere die Sichtbarkeit des Warenkorb-Zählers
    document.querySelectorAll('.header__cart-count, [data-js-cart-indicator]').forEach(element => {
      if (count > 0) {
        // Bei Artikeln im Warenkorb: Zähler per Klasse einblenden
        element.classList.add('is-visible');
        element.classList.remove('is-hidden');
      } else {
        // Bei leerem Warenkorb: Klassen setzen, kein Inline-Style
        element.classList.remove('is-visible');
        element.classList.add('is-hidden');
      }
    });
    
    // Aktualisiere auch den Warenkorb-Status im localStorage
    try {
      localStorage.setItem('cart_count', count);
    } catch (e) {
      // Could not update cart count in localStorage
    }
  }

  // Aktualisiert beim Oeffnen des Drawers die alternativen Produkte.
  // Geoeffnet wird der Drawer NICHT hier, sondern von der Alpine-Komponente:
  // @open-cart.window="open = true; ..." in
  // sections/digitalsprung-cart-drawer.liquid. Hier steht nur der imperative
  // Methodenaufruf, den Alpine deklarativ nicht abbilden kann.
  window.addEventListener("open-cart", function (event) {
    // Get the cart drawer instance
    const cartDrawerElement = document.querySelector('.ds-cart-drawer');
    if (cartDrawerElement && cartDrawerElement._x_dataStack) {
      const cartDrawerInstance = cartDrawerElement._x_dataStack[0];
      
      // Call updateAlternativeProducts to refresh the alternative products container
      if (cartDrawerInstance && typeof cartDrawerInstance.updateAlternativeProducts === 'function') {
        cartDrawerInstance.updateAlternativeProducts();
      }
    }
  });
  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

const _dsSetCookie = (name, value, days = 7, path = "/") => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie =
    name +
    "=" +
    encodeURIComponent(value) +
    "; expires=" +
    expires +
    "; path=" +
    path;
};

const _dsGetCookie = (name) => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

const _dsDeleteCookie = (name, path = "/") => {
  document.cookie =
    name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=" + path;
};

// Namen der Cookies, in denen der zuletzt akzeptierte Rabattcode liegt.
const DISCOUNT_CODE_COOKIES = ["discount_code", "discount_code_referrer"];

// Liest die wirksamen Rabattcodes aus einer /cart.js-Antwort.
// cart.discount_codes ist die einzige Quelle, die fuer ALLE Codearten stimmt -
// auch fuer reine Versandkosten-Codes, die weder total_discount noch
// cart_level_discount_applications beeinflussen. Nicht anwendbare Codes bleiben
// mit applicable:false in der Liste stehen.
//
// Dieser Shop erlaubt bewusst nur EINEN Rabattcode gleichzeitig (weder im
// Warenkorb noch im Checkout werden Codes kombiniert). Die Liste sollte daher
// hoechstens einen Eintrag haben; mehr wird als Konfigurationsfehler geloggt.
const _dsGetApplicableCartCodes = (cartData) => {
  return ((cartData && cartData.discount_codes) || [])
    .filter((candidate) => candidate && candidate.applicable)
    .map((candidate) =>
      String(candidate.code || candidate.title || "").toUpperCase()
    )
    .filter(Boolean);
};

// Der eine wirksame Code - oder null.
const _dsGetActiveCartCode = (cartData) => {
  const codes = _dsGetApplicableCartCodes(cartData);
  if (codes.length > 1) {
    console.warn(
      "[Cart] Mehrere wirksame Rabattcodes im Warenkorb, erwartet war einer:",
      codes
    );
  }
  return codes.length ? codes[0] : null;
};

const dsCartDrawer = ({
  freeShipping,
  gifts,
  upsells,
  allProducts,
  alternativeProducts,
}) => {
  // Create the component instance
  const instance = {
    cart: null,
    total_price: 0,
    total_price_after_discount: 0,
    total_price_without_discount: 0,
    allProducts: allProducts,
    upsells: upsells,
    upsellsAvailable: false,
    upsellProducts: [],
    alternativeProducts: alternativeProducts || [],
    alternativeProductsToShow: [],
    discount: 0,
    discount_applications: [],
    upsellProduct: null,
    recommendations: {},
    giftEligibility: {},
    itemsPaid: [],
    allPaidItems: [],
    freeShippingFromDiscountCode: false,
    itemsFree: [],
    discountCodeInput: null,
    validDiscountCode: null,
    codeStatus: null,
    // Rohliste aus cart.discount_codes: alle am Warenkorb haengenden Codes
    // inkl. applicable-Flag. Massgeblich dafuer, welcher Code wirklich greift.
    discount_codes: [],
    // Grund fuer codeStatus == "invalid":
    //   "not_applicable" - Code gilt fuer diesen Warenkorb nicht
    //   "already_active" - es ist bereits ein anderer Code eingeloest
    codeErrorReason: null,
    discountedTotal: null,
    open: false,
    firstTimeOpened: false,
    shippingCost: 499,
    loading: false,
    discountLoading: false,
    items: [],
    choiceOverlay: false,
    //Section Cart Gifts
    freeShipping: freeShipping,
    gifts: gifts,
    selectedGifts: [],
    giftChoiceOpen: false,
    alert: false,
    giftSelectionSuccessful: false,
    selectedFreeVariants: [],
    nextGift: null,
    //End Cart Gifts
    sortGiftsBy(prop) {
      return function (a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },
    giftAlreadyClaimed(giftProduct) {
      return this.items.find((s) => s.product_id == giftProduct.id);
    },
    isSelectableGift(item) {
      for (const gift of this.gifts) {
        if (
          gift.max != undefined &&
          gift.products.find((product) => product.id == item.product_id)
        ) {
          return true;
        }
      }
      return false;
    },
    getCompareAtPrice(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.compare_at_price;
      }
      return false;
    },
    getTotalCompareAtPrice() {
      let total = 0;
      for (const item of this.items) {
        let compareAtPrice = this.getCompareAtPrice(item.variant_id);
        if (!compareAtPrice) compareAtPrice = item.price;
        if (compareAtPrice) {
          total += compareAtPrice * item.quantity;
        }
      }
      return total;
    },
    getTotalSavings() {
      return this.getTotalCompareAtPrice() - this.total_price;
    },
    getUnitPrice(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.unit_price;
      }
      return false;
    },
    getVariantTitle(variant_id) {
      const p = this.allProducts.find((p) => {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return true;
        return false;
      });
      if (p) {
        const { variants } = p;
        const variant = variants.find((variant) => variant.id == variant_id);
        if (variant) return variant.variant_title;
      }
      return false;
    },
    // Hilfsfunktion, um den höchsten aktiven Tier-Wert zu ermitteln
    getHighestTierValue() {
      // Werte aus dem Editor kommen in Euro, müssen in Cent umgerechnet werden
      const firstTierPrice = (this.freeShipping.first_tier_price || 0) * 100;
      const secondTierPrice = (this.freeShipping.second_tier_price || 0) * 100;
      const freeShippingFrom = this.freeShipping.free_from;
      
      // Wenn second-tier nicht gesetzt ist (0 oder nicht vorhanden), ignoriere ihn bei der Berechnung
      if (secondTierPrice <= 0) {
        // Wenn first-tier gesetzt ist, verwende ihn als höchsten Wert, ansonsten freeShippingFrom
        return firstTierPrice > 0 ? Math.max(freeShippingFrom, firstTierPrice) : freeShippingFrom;
      }
      
      // Wenn second-tier gesetzt ist, verwende den höchsten Wert wie bisher
      return Math.max(freeShippingFrom, firstTierPrice, secondTierPrice);
    },
    
    // Berechnet die Position der Icons basierend auf dem Tier
    getIconPosition(tier) {
      // Werte aus dem Editor kommen in Euro, müssen in Cent umgerechnet werden
      const freeShippingFrom = this.freeShipping.free_from;
      const firstTierPrice = (this.freeShipping.first_tier_price || 0) * 100;
      const secondTierPrice = (this.freeShipping.second_tier_price || 0) * 100;
      
      // Verwende die gleiche Logik wie in getHighestTierValue()
      let maxValue;
      if (secondTierPrice <= 0) {
        // Wenn second-tier nicht gesetzt ist, verwende first-tier oder freeShippingFrom als Maximum
        maxValue = firstTierPrice > 0 ? Math.max(freeShippingFrom, firstTierPrice) : freeShippingFrom;
      } else {
        // Wenn second-tier gesetzt ist, verwende den höchsten Wert wie bisher
        maxValue = Math.max(freeShippingFrom, firstTierPrice, secondTierPrice);
      }
      
      // Fallback, falls alle Werte 0 sind
      if (maxValue === 0) maxValue = freeShippingFrom || 100;
      
      let position = 0;
      
      if (tier === 'free') {
        position = (freeShippingFrom / maxValue) * 100;
      } else if (tier === 'first' && firstTierPrice > 0) {
        position = (firstTierPrice / maxValue) * 100;
      } else if (tier === 'second' && secondTierPrice > 0) {
        position = (secondTierPrice / maxValue) * 100;
      }
      
      // Begrenze die Position auf 0-100%
      position = Math.max(0, Math.min(100, position));
      
      return `left: ${position}%`;
    },
    
    // Berechnet die Breite des Fortschrittsbalkens
    widthBarStyle() {
      if (this.freeShippingFromDiscountCode) {
        return `width: 100%`;
      }
      return `width: ${this.widthShippingBar()}%`;
    },
    
    // Prüft, ob der kostenlose Versand aktiviert ist
    isFreeShippingActivated() {
      const total = this.total_price_without_discount - this.discount;
      const freeShippingFrom = this.freeShipping.free_from;
      
      if (this.freeShippingFromDiscountCode) {
        return true;
      }
      return total >= freeShippingFrom;
    },
    
    // Prüft, ob die erste Stufe erreicht wurde
    isFirstTierActivated() {
      const total = this.total_price_without_discount - this.discount;
      // Wert aus dem Editor kommt in Euro, muss in Cent umgerechnet werden
      const firstTierPrice = (this.freeShipping.first_tier_price || 0) * 100;
      
      // Nur aktivieren, wenn ein Wert für die erste Stufe gesetzt ist
      if (firstTierPrice > 0) {
        return total >= firstTierPrice;
      }
      return false;
    },
    
    // Prüft, ob die zweite Stufe erreicht wurde
    isSecondTierActivated() {
      const total = this.total_price_without_discount - this.discount;
      // Wert aus dem Editor kommt in Euro, muss in Cent umgerechnet werden
      const secondTierPrice = (this.freeShipping.second_tier_price || 0) * 100;
      
      // Nur aktivieren, wenn ein Wert für die zweite Stufe gesetzt ist und größer als 0 ist
      if (secondTierPrice > 0) {
        return total >= secondTierPrice;
      }
      return false;
    },
    
    // Berechnet die Breite des Fortschrittsbalkens basierend auf dem höchsten aktiven Tier-Wert
    widthShippingBar() {
      // Verwende den tatsächlichen Warenkorb-Preis (total_price) anstelle von total_price_without_discount
      // damit die Compare-at-Preise nicht in die Berechnung einfließen
      let total = this.total_price - this.discount;
      const maxValue = this.getHighestTierValue();
      
      // Wenn der Warenkorb-Wert größer oder gleich dem maximalen Tier-Wert ist, zeige 100% an
      if (total >= maxValue) {
        return 100;
      }
      
      // Berechne den prozentualen Fortschritt und begrenze ihn auf 0-100%
      return Math.min(100, Math.max(0, (total / maxValue) * 100));
    },
    // Nicht mehr im Drawer verwendet: total_price_without_discount wird in
    // applyCartData() gesetzt (dort als Max aus Compare-at-Summe und
    // original_total_price). Bitte nicht daneben neu berechnen.
    calculateTotalPriceWithoutDiscount() {
      this.total_price_without_discount = this.getTotalCompareAtPrice();
    },
    giftsAlreadySelected(blockId) {
      for (let gift of this.gifts) {
        if (gift.id == blockId) {
          let giftsInCart = 0;
          for (const item of this.items) {
            const f = gift.products.find(
              (s) => s.variants[0].id == item.variant_id
            );
            if (f) {
              giftsInCart++;
            }
          }
          return giftsInCart >= gift.max;
        }
      }
      return false;
    },
    freeShippingAfter(money_format) {
      // Verwende den tatsächlichen Warenkorb-Preis (total_price) anstelle von total_price_after_discount
      // damit die Compare-at-Preise nicht in die Berechnung einfließen
      const total = this.total_price - this.discount;
      // Werte aus dem Editor kommen in Euro/100, müssen in Cent umgerechnet werden
      const firstTierPrice = (this.freeShipping.first_tier_price || 0) * 100;
      const secondTierPrice = (this.freeShipping.second_tier_price || 0) * 100;
      const freeShippingFrom = this.freeShipping.free_from;
      
      // Wenn Rabattcode für kostenlosen Versand angewendet wurde
      if (this.freeShippingFromDiscountCode) {
        // Zeige den höchsten verfügbaren Text an
        if (secondTierPrice > 0 && this.freeShipping.final_text) {
          return this.freeShipping.final_text;
        } else if (secondTierPrice > 0 && this.freeShipping.second_tier_text) {
          return this.freeShipping.second_tier_text;
        }
        
        if (firstTierPrice > 0 && this.freeShipping.first_tier_text) {
          return this.freeShipping.first_tier_text;
        }
        
        return this.freeShipping.text_reached;
      }
      
      // Wenn second-tier aktiv ist und erreicht wurde
      if (secondTierPrice > 0 && total >= secondTierPrice) {
        if (this.freeShipping.final_text) {
          return this.freeShipping.final_text;
        } else if (this.freeShipping.second_tier_text) {
          return this.freeShipping.second_tier_text;
        }
      }
      
      // Wenn first-tier aktiv ist und erreicht wurde
      if (firstTierPrice > 0 && total >= firstTierPrice) {
        // Wenn second-tier nicht aktiv ist, zeige den final_text an (first-tier ist das Maximum)
        if (secondTierPrice <= 0 && this.freeShipping.final_text) {
          return this.freeShipping.final_text;
        }
        // Wenn second-tier aktiv ist, zeige den second_tier_text an
        if (secondTierPrice > 0 && this.freeShipping.second_tier_text) {
          return this.freeShipping.second_tier_text;
        }
        // Ansonsten zeige den first_tier_text an
        return this.freeShipping.first_tier_text || this.freeShipping.text_reached;
      }
      
      // Wenn der kostenlose Versand erreicht wurde, aber first-tier noch nicht
      if (total >= freeShippingFrom) {
        if (firstTierPrice > 0 && this.freeShipping.first_tier_text) {
          return this.freeShipping.first_tier_text;
        }
        return this.freeShipping.text_reached;
      }
      
      // Standardfall: Zeige an, wie viel noch bis zum kostenlosen Versand fehlt
      return this.giftDiff(money_format, this.freeShipping, null);
    },
    giftDiff(format, gift, nextGift) {
      let total = this.total_price - this.discount;
      const diff = gift.free_from - total;
      const nextGiftDiff = nextGift?.free_from - total;
      const t = gift.text.replace("[money]", Shopify.formatMoney(diff, format));
      if (diff < 0) {
        return this.freeShipping.text_reached;
      }
      return t.includes("[next_money]")
        ? t.replace("[next_money]", Shopify.formatMoney(nextGiftDiff, format))
        : t;
    },
    // Hilfsfunktion, um zu prüfen, ob Geschenkprozesse laufen
    isGiftProcessRunning() {
      return window.isProcessingGifts || window.isAddingGiftProduct || window.isRemovingFreeItems || window.giftProcessingLock;
    },
  
    // Warte, bis alle Geschenkprozesse abgeschlossen sind
    waitForGiftProcessesToComplete() {
      return new Promise(resolve => {
        const checkProcesses = () => {
          if (this.isGiftProcessRunning()) {
            // Debug info entfernt
            setTimeout(checkProcesses, 500);
          } else {
            // Debug info entfernt
            resolve();
          }
        };
        checkProcesses();
      });
    },
    // Füge ein Geschenkprodukt zum Warenkorb hinzu und warte auf Abschluss der Operation
    addGiftProduct(giftProduct) {
      // Prüfe, ob das Produkt verfügbar ist
      // Wenn available explizit false ist, ist das Produkt nicht verfügbar
      // Wenn inventory_quantity definiert ist und <= 0, ist das Produkt nicht verfügbar
      const inventoryDefined = giftProduct.hasOwnProperty('inventory_quantity') && giftProduct.inventory_quantity !== undefined;
      const isOutOfStock = inventoryDefined && giftProduct.inventory_quantity <= 0;
      const isUnavailable = giftProduct.available === false;
      
      if (isOutOfStock || isUnavailable) {
        return Promise.resolve({ not_available: true });
      }

      // Performance-Optimierung: Prüfe zuerst, ob das Produkt bereits im Warenkorb ist
      if (this.items.some(item => item.variant_id == giftProduct.id)) {
        return Promise.resolve({ already_in_cart: true });
      }
      

      if (typeof ga !== "undefined") {
        ga("send", "event", "Cart", "CartUpsell");
      }
      
      // Prüfe, ob giftProduct.id gültig ist
      if (!giftProduct || !giftProduct.id) {
        return Promise.reject('Invalid gift product');
      }
      
      // Prüfe, ob das Produkt bereits im Warenkorb ist
      const isAlreadyInCart = this.items.some(item => item.variant_id == giftProduct.id);
      if (isAlreadyInCart) {
        // Debug info entfernt
        return Promise.resolve({ already_in_cart: true });
      }
      
      // Zeige genau, was wir als Variant-ID verwenden
      // Debug info entfernt
      // Debug info entfernt
      
      // Erstelle ein Promise, das auf den Abschluss der CartJS-Operation wartet
      return new Promise((resolve, reject) => {
        try {
          // Setze ein Flag, dass wir gerade ein Geschenk hinzufügen
          window.isAddingGiftProduct = true;
          
          // Füge das Geschenkprodukt mit speziellen Eigenschaften hinzu
          // Debug info entfernt
          
          // Erstelle die Properties für das Geschenkprodukt
          const giftProperties = {
            _gift: true,
            _free: true
          };
          
          // Wenn eine gift_block_id vorhanden ist, füge sie zu den Properties hinzu
          if (giftProduct.gift_block_id) {
            giftProperties._gift_block_id = giftProduct.gift_block_id;
            
            // Finde den Mindestpreis (free_from) für dieses Geschenk aus den automaticGiftsData
            if (window.automaticGiftsData && Array.isArray(window.automaticGiftsData)) {
              const giftBlock = window.automaticGiftsData.find(gift => gift.id === giftProduct.gift_block_id);
              if (giftBlock && giftBlock.free_from) {
                // Speichere den Mindestpreis als Property am Warenkorb-Item
                giftProperties._gift_min_price = giftBlock.free_from;
              }
            }
          }
          
          // Originaler CartJS.addItem Aufruf mit erweiterten Properties
          CartJS.addItem(
            giftProduct.id,
            1,
            giftProperties,
            {
              // Erfolgsfall: Verifiziere die tatsächliche Hinzufügung und löse das Promise auf
              success: function(data) {
                // Debug info entfernt
                // Debug info entfernt
                
                // Warte kurz, damit der Warenkorb aktualisiert werden kann
                setTimeout(() => {
                  // Hole den aktuellen Warenkorb, um zu überprüfen, ob das Produkt wirklich hinzugefügt wurde
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                      // Prüfe nach verschiedenen Möglichkeiten (variant_id oder properties)
                      const foundByVariantId = cart.items.some(item => item.variant_id == giftProduct.id);
                      const foundByProperties = cart.items.some(item => 
                        item.properties && 
                        item.properties._gift === 'true' && 
                        item.title === giftProduct.title
                      );
                      
                      // Setze das Flag zurück
                      window.isAddingGiftProduct = false;
                      
                      // Löse das Promise auf
                      resolve(data);
                    })
                    .catch(error => {
                      console.error('Fehler beim Abrufen des Warenkorbs:', error);
                      window.isAddingGiftProduct = false;
                      resolve(data); // Trotzdem auflösen, da der Artikel möglicherweise hinzugefügt wurde
                    });
                }, 500); // Kurze Verzögerung, um sicherzustellen, dass der Warenkorb aktualisiert wurde
              },
              // Fehlerfall: Lehne das Promise ab
              error: function(jqXHR, textStatus, errorThrown) {
                console.error('Error adding gift product:', jqXHR, textStatus, errorThrown);
                window.isAddingGiftProduct = false;
                reject(errorThrown || textStatus);
              }
            }
          );
        } catch (error) {
          console.error('Exception when adding gift product:', error);
          window.isAddingGiftProduct = false;
          reject(error);
        }
      });
    },
    
    // Füge ein Geschenkprodukt mit Wiederholungsversuchen hinzu (für höhere Zuverlässigkeit)
    addGiftProductWithRetry(giftProduct, maxRetries = 3) {
      // Prüfe, ob das Produkt eine gift_block_id hat (von addGiftItemsSequentially)
      if (giftProduct.gift_block_id) {
      }
      return new Promise((resolve, reject) => {
        const attemptAdd = (retriesLeft) => {
          // Führe einen Versuch durch mit der korrekten Block-ID
          this.addGiftProduct(giftProduct)
            .then(result => {
              // Erfolgreich hinzugefügt
              resolve(result);
            })
            .catch(error => {
              console.log(`✗ Fehler beim Hinzufügen des Geschenks: ${error}. Verbleibende Versuche: ${retriesLeft-1}`);
              
              // Wenn noch Versuche übrig sind, warte kurz und versuche es erneut
              if (retriesLeft > 1) {
                setTimeout(() => {
                  attemptAdd(retriesLeft - 1);
                }, 1500); // Warte 1.5 Sekunden zwischen den Versuchen
              } else {
                // Keine Versuche mehr übrig
                reject(`Konnte Geschenk nicht hinzufügen nach ${maxRetries} Versuchen: ${error}`);
              }
            });
        };
        
        // Starte den ersten Versuch
        attemptAdd(maxRetries);
      });
    },
    // Sammelt alle Rabattanwendungen aus einer /cart.js-Antwort.
    // Achtung: /cart.js kennt KEIN cart.discount_applications - das ist der
    // Liquid-Name. Die AJAX-API liefert cart-weite Rabatte unter
    // cart_level_discount_applications und produktbezogene Rabatte nur an den
    // Line Items unter line_level_discount_allocations.
    collectDiscountApplications(cartData) {
      if (!cartData) return [];

      const collected = [];

      const add = (application) => {
        if (!application || !application.title) return;
        const key = String(application.title).toUpperCase();
        const exists = collected.some(
          (entry) => String(entry.title).toUpperCase() === key
        );
        if (!exists) collected.push(application);
      };

      (cartData.cart_level_discount_applications || []).forEach(add);
      // Fallback, falls die Daten aus einer Liquid-Quelle stammen.
      (cartData.discount_applications || []).forEach(add);

      (cartData.items || []).forEach((item) => {
        (item.line_level_discount_allocations || []).forEach((allocation) =>
          add(allocation.discount_application)
        );
      });

      return collected;
    },
    // Leitet codeStatus/validDiscountCode aus dem echten Warenkorb ab.
    // Einzige Stelle, die diese beiden Felder aus Warenkorbdaten setzt - damit
    // Rabatt-Formular und Rabattzeile immer dieselbe Quelle haben.
    syncDiscountCodeStateFromCart(cartData) {
      // cart.discount_codes ist massgeblich: nur ein Eintrag mit
      // applicable:true wirkt sich tatsaechlich aus. Codes, die nicht greifen
      // (z. B. weil bereits ein anderer eingeloest ist), bleiben mit
      // applicable:false in der Liste stehen.
      if (cartData && cartData.discount_codes) {
        this.discount_codes = cartData.discount_codes;
      }

      const source = cartData || { discount_codes: this.discount_codes };
      const activeCode = _dsGetActiveCartCode(source);
      const cartDiscount = cartData
        ? cartData.total_discount || 0
        : this.discount || 0;

      let resolvedBy;

      if (activeCode) {
        this.validDiscountCode = activeCode;
        this.codeStatus = "valid";
        this.codeErrorReason = null;
        resolvedBy = "cart (discount_codes, applicable)";

        // Cookie auf den wirksamen Code ziehen. Der Checkout-Button haengt ihn
        // als ?discount= an - so kann dort nichts landen, was der Warenkorb
        // nicht auch anzeigt.
        DISCOUNT_CODE_COOKIES.forEach((name) =>
          _dsSetCookie(name, activeCode, 1)
        );
      } else {
        // Kein wirksamer Code. Zustand zuruecknehmen UND Cookies loeschen,
        // sonst haengt der Checkout-Button beim naechsten Klick wieder ein
        // ?discount= an und ein im Checkout entfernter Code kommt zurueck.
        // codeStatus == "invalid" bleibt stehen: das ist die Rueckmeldung auf
        // eine gerade abgelehnte Eingabe und soll nicht sofort verschwinden.
        if (this.codeStatus === "valid") {
          resolvedBy = "zurueckgesetzt (kein anwendbarer Code im Warenkorb)";
          this.codeStatus = null;
          this.validDiscountCode = null;
        } else {
          resolvedBy = this.codeStatus === "invalid" ? "abgelehnt" : "kein Code";
          this.validDiscountCode = null;
        }

        DISCOUNT_CODE_COOKIES.forEach((name) => _dsDeleteCookie(name));
      }

      // Ein wirksamer Code, der den Warenwert nicht senkt, kann sich nur auf
      // den Versand auswirken - das ist der Gratisversand-Fall. Nur so laesst
      // sich das aus /cart.js ableiten: Versandrabatte erscheinen weder in
      // total_discount noch in cart_level_discount_applications.
      this.freeShippingFromDiscountCode = !!activeCode && cartDiscount === 0;

    },
    // Versandkosten in Cent, die aktuell auf den Warenkorb aufgeschlagen werden.
    // Einzige Stelle, an der diese Entscheidung getroffen wird - vorher stand
    // dieselbe Bedingung dreimal als Liquid-Ausdruck im Template.
    // freeShipping.free_from und freeShipping.shipping_costs kommen aus den
    // Section-Settings und sind (trotz "(€)" im Label) Cent-Werte.
    shippingAmount() {
      // Loyalty-Codes: echte Versandkosten stehen erst im Checkout fest.
      if (this.validDiscountCode && this.validDiscountCode.startsWith("LOY")) {
        return 0;
      }
      if (this.freeShippingFromDiscountCode) return 0;

      const threshold = (this.freeShipping && this.freeShipping.free_from) || 0;
      if (this.total_price_after_discount >= threshold) return 0;

      return (this.freeShipping && this.freeShipping.shipping_costs) || 0;
    },
    hasFreeShipping() {
      const diff =
        this.freeShipping.free_from - (this.total_price - this.discount);
      if (diff < 0) {
        this.shippingCost = 0;
        return true;
      } else {
        this.shippingCost = this.freeShipping.shipping_costs;
        return false;
      }
    },
    checkMandatories(mandatoryProducts) {
      if (mandatoryProducts == undefined || mandatoryProducts.length == 0) {
        return true;
      }
      let foundCount = 0;
      let notFound = [];
      for (product of mandatoryProducts) {
        if (!this.items.find((s) => s.product_id == product.id)) {
          notFound.push(product);
        }
      }
      return notFound;
    },
    confirmGiftChoice() {
      if (this.selectedFreeVariants.length < this.maxFreeProducts) {
        const free = this.maxFreeProducts - this.selectedFreeVariants.length;
        if (free == 1) {
          alert("Du hast noch ein Geschenk frei");
        } else {
          alert("Du hast noch " + free + " Geschenke frei");
        }
        this.giftSelectionSuccessful = false;
      } else {
        this.giftSelectionSuccessful = true;
        this.choiceOverlay = false;

        let i = 1;
        // Remove other free gifts
        for (const item of this.items) {
          const f = this.selectedFreeVariants.find((s) => s == item.variant_id);
          if (item.price == 0 && !f) {
            CartJS.removeItem(i);
          }
          i++;
        }

        // Add gifts that are not added yet
        for (const variant_id of this.selectedFreeVariants) {
          let alreadyInCart = false;
          const f = this.items.find((item) => item.variant_id == variant_id);

          if (f) alreadyInCart = true;

          if (!alreadyInCart) {
            CartJS.addItem(variant_id, 1);
          }
        }
      }
    },
    changeGift(item) {
      const i = this.items.findIndex((s) => s.id == item.id);
      if (i > -1) CartJS.removeItem(i + 1);
      this.selectedFreeVariants = this.selectedFreeVariants.filter(
        (s) => s != item.variant_id
      );
      this.setGiftToUnfulfilled(item);
    },
    removeGift(item) {
      // Setze Flag, dass wir gerade Gratisprodukte entfernen
      window.isRemovingFreeItems = true;
      
      // Finde das Item im Warenkorb
      const i = this.items.findIndex((s) => s.product_id == item.id);
      
      // Prüfe zusätzlich, ob es sich um ein Gratisprodukt handelt
      // Wir prüfen sowohl den Preis als auch, ob es in einem Gift-Block definiert ist
      const isGiftProduct = i > -1 && (
        this.items[i].price == 0 || 
        this.gifts.some(gift => gift.products.some(p => p.id == item.id))
      );
      
      // Nur entfernen, wenn es ein Gratisprodukt ist
      if (i > -1 && isGiftProduct && this.items[i].price == 0) {

        CartJS.removeItem(i + 1);
      } else if (i > -1) {

      }
      
      // Entferne das Flag nach einer kurzen Verzögerung
      setTimeout(() => {
        window.isRemovingFreeItems = false;

      }, 500);
    },
    setGiftToUnfulfilled(item) {
      for (gift of this.gifts) {
        if (gift.products.find((product) => product.id == item.product_id)) {
          gift.fulfilled = false;
          return;
        }
      }
    },
    toggleFreeProduct(product) {
      if (!product.available) {
        return;
      }

      const variant = product.variants[0].id;

      if (this.selectedFreeVariants.indexOf(variant) == -1) {
        this.selectedFreeVariants.push(variant);
      } else {
        const index = this.selectedFreeVariants.indexOf(variant);
        if (index > -1) {

          this.selectedFreeVariants.splice(index, 1);
        }
      }
      if (this.selectedFreeVariants.length > this.nextGift.max) {
        this.selectedFreeVariants.splice(0, 1);
      }
    },
    isFreeProductSelected(product) {
      const f = this.selectedFreeVariants.find(
        (v) => v.toString() == product.variants[0].id.toString()
      );
      return !!f;
    },
    loadRecommendations() {
      for (const item of this.items) {
        if (!this.recommendations[item.product_id]) {
          this.recommendations[item.product_id] = [];
          const url = `/recommendations/products.json?product_id=${item.product_id}`;
          var $this = this;
          fetch(url)
            .then((response) => response.json())
            .then((data) => {

              $this.recommendations[item.product_id] = data?.products;
              if (data?.products?.length > 0) {
                $this.updateUpsellProduct();
              }
            });
        }
      }
    },
    updateUpsellProduct() {
      this.upsellProduct = null;

      var keys = Object.keys(this.recommendations);
      if (keys.length > 0) {
        for (let i = 0; i < 3; i++) {
          for (const product_id of Object.keys(this.recommendations)) {
            const products = this.recommendations[product_id];
            const hasProduct = this.items.find(
              (item) => item.product_id == product_id
            );

            if (hasProduct && !this.upsellProduct) {
              let newUpsellProduct;
              if (products.length > 0 && products[i]) {
                newUpsellProduct = products[i];
              }
              if (newUpsellProduct && this.cart && this.items.length > 0) {
                const cartProduct = this.items.find(
                  (item) => item.product_id == newUpsellProduct.id
                );

                if (!cartProduct) {
                  this.upsellProduct = newUpsellProduct;
                }
              }
            }
          }
        }
      }
    },
    loadImages() {
      for (const product of this.freeSelectableProducts) {
        fetch(
          `/search?view=id&type=product&q=${encodeURI(
            "id:" + product.productId
          )}`
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.products && response.products.length > 0) {
              if (response.products[0].title) {
                product.title = response.products[0].title;
              }
              product.image = response.products[0].featured_image;
              product.product_worth = response.products[0].product_worth;
              product.available = !!response.products[0].available;
            }
          })
          .catch((err) => {});
      }
    },
    checkFreeItem(item) {

      
      // Prüfe, ob das Produkt ein Gratisprodukt ist
      // Ein Gratisprodukt muss BEIDE Bedingungen erfüllen:
      // 1. Preis = 0
      // 2. Gehört zu einem Gift-Block
      if (item.price == 0) {

        
        // Finde den Gift-Block, zu dem dieses Produkt gehört
        const giftBlock = this.gifts.find(gift => {
          const isInGift = gift.products.some(product => product.id == item.product_id);
          return isInGift;
        });
        
        // Nur wenn das Produkt zu einem Gift-Block gehört, prüfen wir die Bedingungen
        if (giftBlock) {

          
          // Berechne den Warenkorbwert ohne Gratisprodukte
          // Hier berechnen wir den Wert nur aus den bezahlten Produkten
          const paidItemsTotal = this.itemsPaid.reduce((total, item) => total + item.line_price, 0);
          
          // Prüfe, ob der Mindestbestellwert erreicht ist
          const minOrderValueReached = paidItemsTotal >= giftBlock.free_from * 100;

          
          // Prüfe, ob der Maximalbestellwert nicht überschritten ist (falls definiert)
          let maxOrderValueNotExceeded = true;
          if (giftBlock.free_until && giftBlock.free_until > 0) {
            maxOrderValueNotExceeded = paidItemsTotal <= giftBlock.free_until * 100;

          } else {

          }
          
          // Prüfe, ob die erforderlichen Produkte im Warenkorb sind
          let mandatoryProductsInCart = true;
          if (giftBlock.mandatory_products && giftBlock.mandatory_products.length > 0) {
            const missingRequiredProducts = this.checkMandatories(giftBlock.mandatory_products);
            
            if (giftBlock.mandatory_amount == "none") {
              // Keine erforderlichen Produkte, nur Preisschwelle wichtig
              mandatoryProductsInCart = true;
            } else if (giftBlock.mandatory_amount == "one") {
              // Mindestens eines der erforderlichen Produkte muss im Warenkorb sein
              mandatoryProductsInCart = missingRequiredProducts.length <= giftBlock.mandatory_products.length - 1;
            } else {
              // Alle erforderlichen Produkte müssen im Warenkorb sein
              mandatoryProductsInCart = missingRequiredProducts.length == 0;
            }
          }
          

          
          // Wenn der Mindestbestellwert nicht erreicht ist, der Maximalbestellwert überschritten ist
          // oder die erforderlichen Produkte fehlen, dann entferne das Gratisprodukt
          if (!minOrderValueReached || !maxOrderValueNotExceeded || !mandatoryProductsInCart) {

            window.isRemovingFreeItems = true;
            CartJS.removeItemById(item.variant_id);
            
            // Entferne das Flag nach einer kurzen Verzögerung
            setTimeout(() => {
              window.isRemovingFreeItems = false;

            }, 500);
          } else {

          }
        } else {

        }
      } else {

      }
      

    },
    updateCart(cart) {
      if (cart) {
        console.log('update cart')
        
        // Das Cookie befüllt nur noch das Eingabefeld. Ob der Code gültig ist,
        // entscheidet allein der echte Warenkorb (syncDiscountCodeStateFromCart
        // am Ende von refreshCart) bzw. eine echte API-Validierung.
        var discountCodeCookie = _dsGetCookie("discount_code");
        if (discountCodeCookie && !this.discountCodeInput) {
          this.discountCodeInput = discountCodeCookie.toUpperCase();
        }

        // Verwende refreshCart() für alle Preisberechnungen und Warenkorb-Aktualisierungen
        this.refreshCart().then(() => {
          // Zusätzliche Operationen nach der Aktualisierung des Warenkorbs
          this.loadRecommendations();

          // Nachlauf: Ladezustand beenden, Geschenk-Berechtigung pruefen
          const $this = this;
          setTimeout(() => {
            // Hier stand frueher ein triggerCheckout(validDiscountCode ||
            // discountCodeInput). Das lief bei JEDER Warenkorb-Aenderung, legte
            // ueber die Storefront-API einen Wegwerf-Cart an und schrieb dabei
            // die Rabattcode-Cookies mit neuer Laufzeit zurueck. Folge: ein im
            // Checkout entfernter Code kam zurueck, sobald man im Shop den
            // Warenkorb anfasste, weil das Cookie staendig erneuert wurde.
            // Der Rabattcode-Zustand kommt jetzt allein aus refreshCart() ->
            // syncDiscountCodeStateFromCart(). Bitte nicht wieder einbauen.
            $this.loading = false;
            
            // Prüfe Geschenk-Berechtigung am Ende, wenn der Gesamtpreis feststeht
            if (window.checkGiftEligibility && typeof window.checkGiftEligibility === 'function') {
              window.checkGiftEligibility($this.total_price_after_discount);
            }
          }, 100);
        }).catch(error => {
          console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    checkUpsells() {
      this.upsellProducts = [];
      let upsellsAvailable = false;
      for (const upsell of this.upsells) {
        for (const product of upsell.upsell_products) {
          if (this.upsellEligible(product, upsell.mandatory_products)) {
            const exist = this.upsellProducts.find(
              (item) => item.id == product.id
            );
            if (!exist && this.upsellProducts.length < 1)
              this.upsellProducts.push(product);

            upsellsAvailable = true;
          }
        }
      }

      return upsellsAvailable;
    },
    checkAutomaticGifts(gift) {
      // Flag setzen, dass Verarbeitung läuft
      window.isProcessingGifts = true;
      
      try {
        // Prüfe, ob die erforderlichen Produkte im Warenkorb sind
        const missingRequiredProducts = this.checkMandatories(
          gift.mandatory_products
        );
        
        let mandatoryAmountFulfilled = false;
        
        if (gift.mandatory_amount == "none") {
          // Keine erforderlichen Produkte, nur Preisschwelle wichtig
          mandatoryAmountFulfilled = true;
        } else if (gift.mandatory_amount == "one") {
          // Mindestens eines der erforderlichen Produkte muss im Warenkorb sein
          mandatoryAmountFulfilled =
            missingRequiredProducts.length <= gift.mandatory_products.length - 1;
        } else {
          // Alle erforderlichen Produkte müssen im Warenkorb sein
          mandatoryAmountFulfilled = missingRequiredProducts.length == 0;
        }
        
        // Prüfe, ob der Rabattcode übereinstimmt
        let codeMatches = true;
        
        if (gift.code && gift.code !== "") {
          // Wenn ein Code angegeben ist, prüfe auf Übereinstimmung
          codeMatches = false;
          
          // Teile den Code-String bei Kommas auf und entferne Leerzeichen
          const giftCodes = gift.code.split(',').map(code => code.trim());
          
          // Prüfe jeden Code einzeln
          if (this.discountCodeInput) {
            const userCode = this.discountCodeInput.toUpperCase();
            
            // Ein Code muss entweder exakt übereinstimmen oder mit dem hinterlegten Code beginnen
            for (const code of giftCodes) {
              if (code && (
                // Exakte Übereinstimmung
                userCode === code.toUpperCase() ||
                // Präfix-basierte Übereinstimmung: Der eingegebene Code beginnt mit dem hinterlegten Code
                userCode.startsWith(code.toUpperCase())
              )) {
                codeMatches = true;
                if (userCode === code.toUpperCase()) {
                  // Debug info entfernt
                } else {
                  // Debug info entfernt
                }
                break;
              }
            }
          }
        }
  
        // Berechne den aktuellen Warenkorbwert ohne Gratisprodukte
        // Hier berechnen wir den Wert nur aus den bezahlten Produkten
        const paidItemsTotal = this.itemsPaid.reduce((total, item) => total + item.line_price, 0);
        
        // Prüfe, ob der Mindestbestellwert erreicht ist
        const minOrderValueReached = paidItemsTotal >= gift.free_from * 100;
  
        // Prüfe, ob der Maximalbestellwert nicht überschritten ist (falls definiert)
        let maxOrderValueNotExceeded = true;
        if (gift.free_until && gift.free_until > 0) {
          maxOrderValueNotExceeded = paidItemsTotal <= gift.free_until * 100;
        }
        
        // Prüfe, ob alle Bedingungen erfüllt sind
        const allConditionsMet = minOrderValueReached && maxOrderValueNotExceeded && mandatoryAmountFulfilled && codeMatches;
        
        // Debug info entfernt
        // Debug info entfernt
        // Debug info entfernt
        // Debug info entfernt
        // Debug info entfernt
        // Debug info entfernt
        
        // Setze den Status des Geschenks
        gift.fulfilled = allConditionsMet;
        
        // Alle Entfernungsoperationen in Promise-Kette zusammenfassen
        const removePromises = [];
        
        // Erst alle zu entfernenden Produkte identifizieren
        const productsToRemove = [];
        
        // Für jedes Produkt im Gift-Block prüfen
        for (let product of gift.products) {
          // Finde alle Artikel im Warenkorb, die zu diesem Produkt gehören
          const matchingItems = this.items.filter(item => item.product_id == product.id);
          
          for (const item of matchingItems) {
            // Prüfe, ob das Item zu diesem Gift-Block gehört oder keinem Block zugeordnet ist
            const itemGiftBlockId = item.properties && item.properties._gift_block_id;
            const belongsToThisBlock = itemGiftBlockId === gift.id;
            const hasNoBlockAssigned = item.price == 0 && (!item.properties || !item.properties._gift_block_id);
            
                    // Entferne das Produkt nur, wenn ALLE diese Bedingungen zutreffen:
            // 1. Es gehört zu diesem Block ODER hat keine Block-Zuordnung (für Abwärtskompatibilität)
            // 2. Es wurde NICHT manuell entfernt (prüfe mit Block-ID)
            // 3. Die Bedingungen für diesen Block sind NICHT erfüllt
            if ((belongsToThisBlock || hasNoBlockAssigned) && 
                !this.wasGiftManuallyRemoved(product.id, gift.id) && 
                !allConditionsMet) {
              // Debug info entfernt
              productsToRemove.push(item.variant_id);
            }
          }
        }

        // Setze den nächsten Gift-Block, wenn die Bedingungen nicht erfüllt sind,
        // aber der Rabattcode übereinstimmt
        if (!allConditionsMet) {
          if (codeMatches) {
            if (this.nextGift == null || 
                (this.nextGift != null && !this.nextGift.fulfilled && this.nextGift?.free_from > gift.free_from) ||
                (this.nextGift != null && this.nextGift.fulfilled)) {
              this.nextGift = gift;
            }
          } else {
            // Wenn der Rabattcode nicht übereinstimmt, markiere das Geschenk als erfüllt
            // und setze den nächsten Gift-Block zurück
            gift.fulfilled = true;
            this.nextGift = undefined;
          }
        }

        // Sequentiell entfernen und dann ggf. hinzufügen
        return this.removeGiftItemsSequentially(productsToRemove)
          .then(() => {
            // Minimale Pause nach dem Entfernen, bevor wir mit dem Hinzufügen beginnen
            return new Promise(resolve => setTimeout(resolve, 500));
          })
          .then(() => {
            // Erst nach erfolgreichem Entfernen mit Hinzufügen beginnen
            if (allConditionsMet) {
              // Debug info entfernt
              
              // Aktualisiere die Warenkorb-Daten, um sicherzustellen, dass wir den aktuellen Stand haben
              return fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  // Aktualisiere die lokalen Warenkorb-Daten
                  this.items = cart.items;
                  
                  // Debug info entfernt
                  
                  // Jetzt mit den aktualisierten Daten die Produkte filtern
                  const productsToAdd = gift.products.filter(product => {
                    // Prüfe, ob das Produkt bereits im Warenkorb ist und zu diesem Block gehört
                    const matchingItems = this.items.filter(item => item.product_id == product.id);
                    
                                    // Prüfe, ob das Produkt bereits im Warenkorb ist und zu diesem Block gehört
                    // Wir betrachten ein Produkt als "im Warenkorb", wenn es:
                    // 1. Die gleiche Produkt-ID hat UND
                    // 2. Entweder die gleiche Block-ID hat ODER keine Block-ID hat (für Abwärtskompatibilität)
                    const inCart = matchingItems.some(item => {
                      const itemBlockId = item.properties && item.properties._gift_block_id;
                      return itemBlockId === gift.id || !itemBlockId;
                    });
                    
                    // Prüfe, ob das Produkt manuell entfernt wurde - WICHTIG: mit der Block-ID prüfen
                    const wasRemoved = this.wasGiftManuallyRemoved(product.id, gift.id);
                    
                    // Nur relevante Informationen loggen
                    if (inCart || wasRemoved) {
                      // Debug info entfernt
                    }
                    
                    // Füge nur Produkte hinzu, die nicht im Warenkorb und nicht manuell entfernt wurden
                    return !inCart && !wasRemoved;
                  });
                  
                  // Ende der Produktprüfung
                  
                  if (productsToAdd.length > 0) {
                    // Debug info entfernt
                    
                    // Füge die gift_block_id zu jedem Produkt hinzu
                    const productsWithBlockId = productsToAdd.map(product => ({
                      ...product,
                      gift_block_id: gift.id // Wichtig: Füge die Block-ID hinzu
                    }));
                    
                    // Debug info entfernt
                    
                    return this.addGiftItemsSequentially(productsWithBlockId);
                  } else {
                    // Debug info entfernt
                    return Promise.resolve();
                  }
                });
            }
            return Promise.resolve();
          })
          .finally(() => {
            // Flag zurücksetzen
            // Debug info entfernt
            // Debug info entfernt
            window.isProcessingGifts = false;
          });
      } catch (error) {
        console.error('Fehler bei der Prüfung der automatischen Geschenke:', error);
        // Stelle sicher, dass das Flag auch im Fehlerfall zurückgesetzt wird
        window.isProcessingGifts = false;
        return Promise.reject(error);
      }
    },
    checkSelectedGifts(gift) {
      // Prüfe, ob der Rabattcode übereinstimmt
      let codeMatches = true;
      
      if (gift.code && gift.code !== "") {
        // Wenn ein Code angegeben ist, prüfe auf Übereinstimmung
        codeMatches = false;
        
        // Teile den Code-String bei Kommas auf und entferne Leerzeichen
        const giftCodes = gift.code.split(',').map(code => code.trim());
        
        // Prüfe jeden Code einzeln
        if (this.discountCodeInput) {
          const userCode = this.discountCodeInput.toUpperCase();
          
          // Ein Code muss exakt übereinstimmen
          for (const code of giftCodes) {
            if (code && userCode === code.toUpperCase()) {
              codeMatches = true;
              break;
            }
          }
        }
      }

      // Wenn der Rabattcode nicht übereinstimmt, beende frühzeitig
      if (gift.code && !codeMatches) {
        gift.fulfilled = false;
        return;
      }
      
      // Prüfe, ob die erforderlichen Produkte im Warenkorb sind
      const missingProductsInCart = this.checkMandatories(
        gift.mandatory_products
      );
      
      // Prüfe, ob die Bedingungen für die erforderlichen Produkte erfüllt sind
      let mandatoryAmountFulfilled = false;
      if (gift.mandatory_amount == "one") {
        // Mindestens eines der erforderlichen Produkte muss im Warenkorb sein
        mandatoryAmountFulfilled =
          missingProductsInCart.length <= gift.mandatory_products.length - 1;
      } else {
        // Alle erforderlichen Produkte müssen im Warenkorb sein
        mandatoryAmountFulfilled = missingProductsInCart.length == 0;
      }

      // Wenn keine erforderlichen Produkte definiert sind, ist die Bedingung erfüllt
      if (gift.mandatory_products?.length == 0) {
        mandatoryAmountFulfilled = true;
      }

      // Berechne den aktuellen Warenkorbwert mit Rabatten
      const currentCartValue = this.getDiscountedTotal();
      
      // Prüfe, ob der Mindestbestellwert erreicht ist
      const minOrderValueReached = currentCartValue >= gift.free_from * 100;
      
      // Setze die Auswählbarkeit der Varianten
      gift.variantPickable = mandatoryAmountFulfilled && minOrderValueReached;
      
      // Prüfe, ob alle Bedingungen erfüllt sind
      const allConditionsMet = minOrderValueReached && mandatoryAmountFulfilled && codeMatches;
      
      if (!allConditionsMet) {
        // Wenn die Bedingungen nicht erfüllt sind, entferne die Geschenke
        for (let product of gift.products) {
          const index = this.items.findIndex((s) => s.product_id == product.id);
          if (index > -1) {
            // Entferne das Geschenk aus dem Warenkorb
            this.removeGift(product);
          }
        }
        
        // Setze den nächsten Gift-Block, wenn der Rabattcode übereinstimmt
        if (codeMatches) {
          if (this.nextGift == null || 
              (this.nextGift != null && !this.nextGift.fulfilled && this.nextGift?.free_from > gift.free_from) ||
              (this.nextGift != null && this.nextGift.fulfilled)) {
            this.nextGift = gift;
          }
        }
        
        gift.fulfilled = false;
      } else {
        // Wenn alle Bedingungen erfüllt sind, prüfe, ob alle Geschenke im Warenkorb sind
        if (this.allGiftsInCart(gift)) {
          // Alle Geschenke sind bereits im Warenkorb
          gift.fulfilled = true;
          
          // Wenn dieses Geschenk das nächste ist, setze es zurück
          if (this.nextGift == gift) {
            this.nextGift = null;
          }
        } else {
          // Nicht alle Geschenke sind im Warenkorb, setze dieses als nächstes
          this.nextGift = gift;
          gift.fulfilled = false;
        }
      }
    },
    getDiscountedTotal() {
      return this.discountedTotal && _dsGetCookie("discount_code")
        ? this.discountedTotal
        : this.total_price;
    },
    allGiftsInCart(gift) {
      let found = 0;
      for (product of gift.products) {
        const index = this.items.findIndex((s) => s.product_id == product.id);
        if (index > -1) {
          found++;
        }
      }
      return found == gift.max;
    },
    upsellEligible(item, mandatoryProducts) {
      let found = false;
      const index = this.items.findIndex((s) => s.product_id == item.id);
      if (index > -1) {
        found = true;
      }
      let missingProducts = this.checkMandatories(mandatoryProducts);
      return !found && missingProducts.length < mandatoryProducts.length;
    },
    
    // Stellt sicher, dass alle Gratisprodukte im Warenkorb immer nur eine Menge von 1 haben
    ensureGiftQuantityIsOne() {      
      // Wenn Geschenkprozesse laufen, warte mit der Mengenänderung
      if (this.isGiftProcessRunning()) {
        // Debug info entfernt
        
        // Warte auf Abschluss aller Prozesse und führe dann die Mengenanpassung durch
        return this.waitForGiftProcessesToComplete()
          .then(() => this._adjustGiftQuantities())
          .catch(error => {
            console.error('Fehler beim Warten auf Geschenkprozesse:', error);
            return Promise.reject(error);
          });
      } else {
        // Keine laufenden Prozesse, führe die Mengenanpassung direkt durch
        return this._adjustGiftQuantities();
      }
    },
    
    // Interne Hilfsfunktion zur Anpassung der Gratisprodukt-Mengen
    _adjustGiftQuantities() {
      // Debug info entfernt
      
      // Sammle alle Gratisprodukte, deren Menge angepasst werden muss
      const itemsToAdjust = [];
      
      // Prüfe alle Artikel im Warenkorb
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        
        // Prüfe, ob es sich um ein Gratisprodukt handelt (Preis = 0)
        if (item.price === 0 || item.properties?._gift === true || item.properties?._free === true) {
          // Wenn die Menge größer als 1 ist, merke dir das Item zur Anpassung vor
          if (item.quantity > 1) {
            itemsToAdjust.push({
              index: i + 1, // CartJS.updateItem verwendet 1-basierte Indizes
              item: item
            });
          }
        }
      }
      
      // Wenn keine Anpassungen nötig sind, beende sofort
      if (itemsToAdjust.length === 0) {
        // Debug info entfernt
        return Promise.resolve();
      }
      
      // Debug info entfernt
      
      // Führe die Anpassungen sequentiell durch
      return itemsToAdjust.reduce((promise, adjustment) => {
        return promise.then(() => {
          // Debug info entfernt
          
          return new Promise((resolve, reject) => {
            try {
              CartJS.updateItem(adjustment.index, 1, {
                _gift: true,
                _free: true
              }, {
                success: () => {
                  // Debug info entfernt
                  resolve();
                },
                error: (error) => {
                  console.error('Fehler beim Anpassen der Gratisprodukt-Menge:', error);
                  // Trotz Fehler weitermachen
                  resolve();
                }
              });
            } catch (error) {
              console.error('Exception beim Anpassen der Gratisprodukt-Menge:', error);
              // Trotz Fehler weitermachen
              resolve();
            }
          });
        });
      }, Promise.resolve());
    },
  

    // Verringere die Menge eines Warenkorb-Elements um 1 oder entferne es, wenn die Menge unter 1 fällt
    decreaseQuantity(item) {
      if (!item) return Promise.resolve();
      
      // Wenn die Menge bereits 1 ist, entferne das Produkt
      if (item.quantity <= 1) {
        return this.removeItem(item);
      }
      
      // Ansonsten verringere die Menge um 1
      return this.updateCartItemQuantity(item, item.quantity - 1)
        .catch(error => {
          console.error('Fehler beim Verringern der Menge:', error);
        });
    },

    // Erhöhe die Menge eines Warenkorb-Elements um 1
    increaseQuantity(item) {
      if (!item) return Promise.resolve();
      
      return this.updateCartItemQuantity(item, item.quantity + 1)
        .catch(error => {
          console.error('Fehler beim Erhöhen der Menge:', error);
        });
    },
    
    // Aktualisiert die Menge eines Warenkorb-Elements sicher und wartet auf Abschluss
    updateCartItemQuantity(item, newQuantity) {
      this.loading = true;
      
      // Sicherstellen, dass newQuantity eine gültige Zahl ist
      newQuantity = Math.max(0, parseInt(newQuantity) || 0);
      
      // Warte auf Abschluss aller Geschenkprozesse, bevor die Menge geändert wird
      return this.waitForGiftProcessesToComplete()
        .then(() => {
          return new Promise((resolve, reject) => {
            try {
              
              // Prüfen, ob das Item einen gültigen Key hat
              if (!item || !item.key) {
                this.loading = false;
                return reject(new Error('Ungültiges Warenkorb-Element (kein Key vorhanden)'));
              }
              
              // Verwende die Shopify Cart API direkt mit dem Line Item Key
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,  // Verwende den eindeutigen Line Item Key
                  quantity: newQuantity
                })
              })
              .then(response => {
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
              })
              .then(data => {
                this.loading = false;
                // Aktualisiere den lokalen Warenkorb
                this.refreshCart();
                resolve(data);
              })
              .catch(error => {
                this.loading = false;
                
                // Erstelle eine bessere Fehlermeldung mit Details
                const errorDetails = {
                  error: error.message,
                  itemInfo: {
                    key: item.key,
                    variant_id: item.variant_id,
                    quantity: item.quantity,
                    newQuantity: newQuantity
                  }
                };
                
                reject(error);
              });
            } catch (error) {
              this.loading = false;
              reject(error);
            }
          });
        })
        .catch(error => {
          this.loading = false;
          return Promise.reject(error);
        });
    },
    
    removeItem(item) {
      this.loading = true;
      
      // Wenn es ein Gratisprodukt ist (Preis = 0), füge es zur Liste der manuell entfernten Produkte hinzu
      if (item.price == 0) {
        // Prüfe, ob das Item Eigenschaften hat und ob es einen gift_block_id gibt
        const giftBlockId = item.properties && item.properties._gift_block_id;
        
        
        if (giftBlockId) {
          // Speichere sowohl Produkt-ID als auch Gift-Block-ID
          window.manuallyRemovedGifts.push({
            productId: item.product_id,
            giftBlockId: giftBlockId
          });
        } else {
          // Fallback für ältere Einträge ohne Block-ID
          window.manuallyRemovedGifts.push(item.product_id);
        }
        
        // Tracking-Information für manuelle Entfernung
      }
      
      // Verwende den eindeutigen Line Item Key anstelle des Index
      if (!item || !item.key) {
        this.loading = false;
        return Promise.reject(new Error('Ungültiges Warenkorb-Element (kein Key vorhanden)'));
      }
            
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => {
        this.loading = false;
        // Aktualisiere den lokalen Warenkorb
        this.refreshCart();
        return data;
      })
      .catch(error => {
        this.loading = false;
        throw error;
      });
    },
    
    // Funktion zum Prüfen, ob ein Gratisprodukt manuell entfernt wurde
    wasGiftManuallyRemoved(productId, giftBlockId = null) {
      let result = false;
      
      // Wenn kein giftBlockId angegeben ist, prüfe nur nach productId (für Abwärtskompatibilität)
      if (giftBlockId === null) {
        // Prüfe sowohl alte Einträge (nur productId) als auch neue Einträge (Objekte)
        result = window.manuallyRemovedGifts.some(item => 
          item === productId || (typeof item === 'object' && item.productId === productId)
        );
      } else {
        // Wenn giftBlockId angegeben ist, prüfe nach beiden IDs
        result = window.manuallyRemovedGifts.some(item => 
          (typeof item === 'object' && item.productId === productId && item.giftBlockId === giftBlockId)
        );
      }
      
      return result;
    },
    
    // Funktion zum Löschen von manuell entfernten Geschenken für einen bestimmten Block
    clearManuallyRemovedGifts(giftBlockId = null) {
      if (giftBlockId === null) {
        // Wenn keine Block-ID angegeben ist, lösche alle manuell entfernten Geschenke
        window.manuallyRemovedGifts = [];
      } else {
        // Wenn eine Block-ID angegeben ist, lösche nur die Geschenke für diesen Block
        const initialLength = window.manuallyRemovedGifts.length;
        window.manuallyRemovedGifts = window.manuallyRemovedGifts.filter(item => 
          !(typeof item === 'object' && item.giftBlockId === giftBlockId)
        );
        const removedCount = initialLength - window.manuallyRemovedGifts.length;
      }
      return this;
    },
    
    // Entferne ein Geschenkprodukt anhand seiner Variant-ID und warte auf Abschluss
    removeGiftItemById(variantId) {
      // Erstelle ein Promise, das auf den Abschluss der CartJS-Operation wartet
      return new Promise((resolve, reject) => {
        try {
          CartJS.removeItemById(
            variantId,
            {
              // Erfolgsfall: Löse das Promise auf
              success: function(data) {
                resolve(data);
              },
              // Fehlerfall: Lehne das Promise ab
              error: function(jqXHR, textStatus, errorThrown) {
                reject(errorThrown || textStatus);
              }
            }
          );
        } catch (error) {
          reject(error);
        }
      });
    },
    
    // Promise-basierte Methode zum sequentiellen Entfernen von Gratisprodukten mit Verifizierung
    removeGiftItemsSequentially(variantIds) {
      if (!variantIds || variantIds.length === 0) {
        return Promise.resolve();
      }
      
      // Flag setzen
      window.isRemovingFreeItems = true;
            
      // Sequentiell entfernen mit Promises und Verifizierung
      return variantIds.reduce((promise, variantId) => {
        return promise.then(() => {
          return this.removeGiftItemByIdWithVerification(variantId);
        });
      }, Promise.resolve())
      .finally(() => {
        // Flag zurücksetzen nach Abschluss aller Operationen
        window.isRemovingFreeItems = false;
      });
    },
    
    // Entferne ein Geschenkprodukt und verifiziere, dass es wirklich entfernt wurde - präzisere Version
    removeGiftItemByIdWithVerification(variantId, maxAttempts = 3) {
      
      return new Promise((resolve, reject) => {
        // Funktion zum Prüfen, ob das Produkt noch im Warenkorb ist
        const checkIfRemoved = async (attemptsLeft) => {
          try {
            // Hole den aktuellen Warenkorb
            const response = await fetch('/cart.js');
            const cart = await response.json();
            
            // Prüfe, ob das Produkt noch im Warenkorb ist
            const isStillInCart = cart.items.some(item => item.variant_id == variantId);
            
            if (!isStillInCart) {
              // Produkt wurde erfolgreich entfernt
              resolve();
              return;
            }
            
            // Produkt ist noch im Warenkorb
            if (attemptsLeft <= 0) {
              // Keine Versuche mehr übrig, trotzdem als erfolgreich betrachten
              resolve();
              return;
            }
            
            
            // Entferne das Produkt erneut
            await this.removeGiftItemById(variantId);
            
            // Warte kurz und prüfe erneut
            setTimeout(() => {
              checkIfRemoved(attemptsLeft - 1);
            }, 500);
          } catch (error) {
            console.error(`Fehler beim Verifizieren der Entfernung von Variante ${variantId}:`, error);
            // Bei einem Fehler trotzdem fortfahren
            resolve();
          }
        };
        
        // Starte den ersten Entfernungsversuch
        this.removeGiftItemById(variantId)
          .then(() => {
            // Warte kurz und prüfe dann, ob das Produkt wirklich entfernt wurde
            setTimeout(() => {
              checkIfRemoved(maxAttempts - 1);
            }, 500);
          })
          .catch(error => {
            console.error(`Fehler beim ersten Entfernungsversuch für Variante ${variantId}:`, error);
            // Bei einem Fehler trotzdem mit der Verifizierung fortfahren
            setTimeout(() => {
              checkIfRemoved(maxAttempts - 1);
            }, 500);
          });
      });
    },
    
    // Promise-basierte Methode zum sequentiellen Hinzufügen von Gratisprodukten mit Verifizierung
    addGiftItemsSequentially(products) {
      if (!products || products.length === 0) {
        return Promise.resolve();
      }
            
      // Nur Produkte mit Varianten filtern und die erste Variante nehmen
      const validProducts = products.filter(p => p && p.variants && p.variants.length > 0)
        .map(p => ({
          productId: p.id, 
          variant: p.variants[0], 
          title: p.title || 'Unbekannt',
          // Wenn das Produkt eine gift_block_id hat, übernehme sie in die Variante
          gift_block_id: p.gift_block_id || null
        }));
      
      if (validProducts.length === 0) {
        return Promise.resolve();
      }
      
      
      // Sequentiell hinzufügen mit Promises und Verifizierung
      return new Promise((resolve, reject) => {
        const addProductAtIndex = (index) => {
          if (index >= validProducts.length) {
            resolve();
        return;
      }
      
      const product = validProducts[index];
          
          // Stelle sicher, dass die gift_block_id an die Variante übergeben wird
          if (product.gift_block_id) {
            // Füge die gift_block_id zur Variante hinzu
            product.variant.gift_block_id = product.gift_block_id;
          }
          
          // Füge das Produkt hinzu mit Verifizierung
      this.addGiftProductWithVerification(product.variant)
        .then(() => {
          addProductAtIndex(index + 1);
        })
        .catch(error => {
          addProductAtIndex(index + 1);
        });
    };
    
    addProductAtIndex(0);
  });
    },
    
    // Füge ein Geschenkprodukt hinzu und verifiziere, dass es wirklich hinzugefügt wurde - präzisere Version
    addGiftProductWithVerification(giftProduct, maxAttempts = 3) {
      
      return new Promise((resolve, reject) => {
        // Funktion zum Prüfen, ob das Produkt im Warenkorb ist
        const checkIfAdded = async (attemptsLeft) => {
          try {
            // Hole den aktuellen Warenkorb
            const response = await fetch('/cart.js');
            const cart = await response.json();
            
            // Prüfe, ob das Produkt im Warenkorb ist
            const isInCart = cart.items.some(item => {
              // Prüfe nach Variant-ID
              const matchesVariantId = item.variant_id == giftProduct.id;
              
              // Prüfe nach Block-ID, falls vorhanden
              let matchesBlockId = true;
              if (giftProduct.gift_block_id) {
                matchesBlockId = item.properties && 
                                 item.properties._gift_block_id === giftProduct.gift_block_id;
              }
              
              return matchesVariantId && matchesBlockId;
            });
            
            if (isInCart) {
              // Produkt wurde erfolgreich hinzugefügt
              resolve();
              return;
            }
            
            // Produkt ist nicht im Warenkorb
            if (attemptsLeft <= 0) {
              // Keine Versuche mehr übrig
              // Bei zu vielen Fehlversuchen trotzdem fortfahren
              resolve();
              return;
            }
            
            // Versuche erneut, das Produkt hinzuzufügen
            
            // Füge das Produkt erneut hinzu
            await this.addGiftProduct(giftProduct);
            
            // Warte kurz und prüfe erneut
            setTimeout(() => {
              checkIfAdded(attemptsLeft - 1);
            }, 500);
          } catch (error) {
            
            if (attemptsLeft <= 0) {
              // Bei zu vielen Fehlversuchen trotzdem fortfahren
              resolve();
            } else {
              // Bei einem Fehler erneut versuchen
              setTimeout(() => {
                checkIfAdded(attemptsLeft - 1);
              }, 500);
            }
          }
        };
        
        // Starte den ersten Hinzufügungsversuch
        this.addGiftProduct(giftProduct)
          .then(() => {
            // Warte kurz und prüfe dann, ob das Produkt wirklich hinzugefügt wurde
            setTimeout(() => {
              checkIfAdded(maxAttempts - 1);
            }, 500);
          })
          .catch(error => {
            // Bei einem Fehler trotzdem mit der Verifizierung fortfahren
            setTimeout(() => {
              checkIfAdded(maxAttempts - 1);
            }, 500);
          });
      });
    },
    
    // Prüft, ob ein Geschenk mit der angegebenen Produkt-ID bereits im Warenkorb ist
giftAlreadyClaimedById(productId) {
      // Prüfe, ob das Produkt im Warenkorb ist
  const isInCart = this.items.some(item => item.product_id == productId);
      
      // Prüfe zusätzlich, ob das Produkt zu einem Gift-Block gehört
  const isGiftProduct = this.gifts.some(gift => 
    gift.products.some(product => product.id == productId)
  );
      
      // Prüfe, ob das Geschenk manuell entfernt wurde
  const wasManuallyRemoved = this.wasGiftManuallyRemoved(productId);
  
      // Ein Geschenk gilt als "claimed", wenn es im Warenkorb ist
  return isInCart;
    },

    // Prüft, ob die Geschenk-Logik ausgeführt werden sollte
shouldCheckGifts(cart) {
      // Wenn keine Geschenke konfiguriert sind, keine Prüfung nötig
  if (!this.gifts || this.gifts.length === 0) {
    return false;
  }
  
  if (window.isRemovingFreeItems || window.isProcessingGifts) {
    return false;
  }
  
  if (this._lastDiscountCode !== this.discountCodeInput) {
    this._lastDiscountCode = this.discountCodeInput;
    return true;
  }
  
  if (!this._lastItemCount || this._lastItemCount !== this.itemsPaid.length) {
    this._lastItemCount = this.itemsPaid.length;
    return true;
  }
  
  const currentTotal = this.total_price - this.discount;
  
  if (!this._lastCartTotal) {
    this._lastCartTotal = currentTotal;
    return true;
  }
  
      // Prüfe, ob relevante Schwellwerte überschritten wurden
      // Iteriere über alle Gift-Blocks und sammle relevante Schwellwerte
      const thresholds = [];
      for (let gift of this.gifts) {
        if (gift.free_from > 0) thresholds.push(gift.free_from * 100);
        if (gift.first_tier_price > 0) thresholds.push(gift.first_tier_price * 100);
        if (gift.second_tier_price > 0) thresholds.push(gift.second_tier_price * 100);
      }
      
      // Prüfe, ob sich der Gesamtpreis geändert hat (unabhängig von Schwellwerten)
  if (currentTotal !== this._lastCartTotal) {
    this._lastCartTotal = currentTotal;
    return true;
  }
  
      // Da wir jetzt bei jeder Preisänderung prüfen, ist die Schwellenprüfung redundant
      // Wir behalten sie als Backup, falls _lastCartTotal aus irgendeinem Grund nicht aktualisiert wird
      for (let threshold of thresholds) {
        if ((this._lastCartTotal < threshold && currentTotal >= threshold) || 
            (this._lastCartTotal >= threshold && currentTotal < threshold)) {
          this._lastCartTotal = currentTotal;
          return true;
        }
}

      // Wenn die Änderung größer als 20% ist, auch neu prüfen
      // Dies fängt größere Änderungen ab, die keine Schwellwerte überschreiten
      if (Math.abs(this._lastCartTotal - currentTotal) > (this._lastCartTotal * 0.2)) {
        this._lastCartTotal = currentTotal;
        return true;
      }
      
      // Speichere den aktuellen Wert für die nächste Prüfung
      this._lastCartTotal = currentTotal;
      
      // In allen anderen Fällen keine Geschenk-Prüfung nötig
      return false;
    },
    
initialize(cart) {
  var $this = this;
  this.$watch("open", (value) => {
    if (value && !$this.firstTimeOpened) {
      $this.firstTimeOpened = true;
    }

    const trans = document.getElementById("rawa-container");
    if (trans) {
      if (value) {
        trans.style.display = "none";
      } else {
        trans.style.display = "block";
      }
    }

    const trustedBadge = document.querySelector(
      "[id^='trustbadge-container']"
    );
    if (trustedBadge) {
      if (value) {
        trustedBadge.style.display = "none";
      } else {
        trustedBadge.style.display = "block";
      }
    }

    var body = document.querySelector("body");
    if (body) {
      if (value) {
        body.classList.add("overflow-hidden");
        
        // Wenn der Warenkorb geöffnet wird, prüfe die Gratisprodukte
        if (!window.isProcessingGifts && !window.giftProcessingLock) {
          
          // Warte kurz, um sicherzustellen, dass der Warenkorb vollständig geladen ist
          setTimeout(() => {
            // Stelle sicher, dass alle Gratisprodukte im Warenkorb immer nur eine Menge von 1 haben
            $this.ensureGiftQuantityIsOne()
              .then(() => {
                // Nach der Mengenanpassung die Geschenke prüfen
                // $this.checkGiftClaims();
              })
              .catch(error => {
                console.error('Fehler bei der Prüfung der Gratisprodukte beim Öffnen des Warenkorbs:', error);
              });
          }, 300);
            }
          } else {
            body.classList.remove("overflow-hidden");
          }
        }
      });

      this.gifts = this.gifts.sort(this.sortGiftsBy("free_from"), "desc");
      if (!cart) return;

      // Preise, Item-Listen und Rabattcode-Zustand kommen aus applyCartData() -
      // derselben Stelle, die auch refreshCart() nutzt. Die Payload aus dem
      // cart-initiated-Event ist bereits eine frische /cart.js-Antwort, ein
      // zweiter Fetch waere hier ueberfluessig.
      this.applyCartData(cart);
      this.loading = false;

      // Aktualisieren der Upsell- und Alternative-Produkte
      this.updateUpsellProducts();
      this.updateAlternativeProducts();
    },
    calculateSavings() {
      const comparePrices = this.itemsPaid
        .map((item) => item.price * item.quantity)
        .reduce((a, b) => a + b, 0);
      const realPrices = this.total_price - this.discount;
      return comparePrices - realPrices;
    },

    checkDiscountGifts(discountCode) {
      // Rufe die Funktion aus der externen Datei auf und übergebe den Kontext und den Code
      window.checkDiscountGifts.call(this, discountCode);
    },

    triggerCheckout(code) {

      // Direkter Aufruf der checkDiscountGifts-Funktion ohne Verzögerung
      this.checkDiscountGifts(code);

      const $this = this;
      $this.discountLoading = true;

      // Vorbereiten der Warenkorb-Items für die Cart API
      const lineItems = this.itemsPaid.map((paidItem) => ({
        merchandiseId: `gid://shopify/ProductVariant/${paidItem.variant_id}`,
        quantity: paidItem.quantity,
      }));

      // Storefront API-Token aus den Metadaten holen
      const storefrontAccessToken = document
        .querySelector('meta[name="shopify-storefront-api-token"]')
        ?.getAttribute("content");

      if (!storefrontAccessToken) {
        $this.discountLoading = false;
        return;
      }

      // GraphQL-Mutation zum Erstellen eines Carts
      const createCartMutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      // Sende Anfrage an die Storefront API
      fetch("https://" + window.location.host + "/api/2023-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
          query: createCartMutation,
          variables: {
            input: {
              lines: lineItems,
            },
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data?.cartCreate?.cart) {
            const cartId = data.data.cartCreate.cart.id;
            const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;

            // Wenn ein Rabattcode vorhanden ist, diesen anwenden
            if (code) {
              return applyDiscountAndRedirect(cartId, checkoutUrl, code);
            } else {
              // Direkt zum Checkout weiterleiten
              window.location.href = checkoutUrl;
              $this.discountLoading = false;
            }
          } else {
            $this.discountLoading = false;
          }
        })
        .catch((error) => {
          $this.discountLoading = false;
        });
    },
    calculateSavings() {
      const comparePrices = this.itemsPaid
        .map((item) => item.price * item.quantity)
        .reduce((a, b) => a + b, 0);
      const realPrices = this.total_price - this.discount;
      return comparePrices - realPrices;
    },
    triggerCheckout(code) {
      const $this = this;
      $this.discountLoading = true;

      // Vorbereiten der Warenkorb-Items für die Cart API
      const lineItems = this.itemsPaid.map((paidItem) => ({
        merchandiseId: `gid://shopify/ProductVariant/${paidItem.variant_id}`,
        quantity: paidItem.quantity,
      }));

      // Storefront API-Token aus den Metadaten holen
      const storefrontAccessToken = document
        .querySelector('meta[name="shopify-storefront-api-token"]')
        ?.getAttribute("content");

      if (!storefrontAccessToken) {
        $this.discountLoading = false;
        return;
      }

      // GraphQL-Mutation zum Erstellen eines Carts
      const createCartMutation = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      // Sende Anfrage an die Storefront API
      fetch("https://" + window.location.host + "/api/2023-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
        },
        body: JSON.stringify({
          query: createCartMutation,
          variables: {
            input: {
              lines: lineItems,
            },
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data?.cartCreate?.cart) {
            const cartId = data.data.cartCreate.cart.id;
            const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;

            // Wenn ein Rabattcode vorhanden ist, diesen anwenden
            if (code) {
              return applyDiscountAndRedirect(cartId, checkoutUrl, code);
            } else {
              // Direkt zum Checkout weiterleiten
              window.location.href = checkoutUrl;
              $this.discountLoading = false;
              // window.checkFreeDiscountProducts();
            }
          } else {
            console.error(
              "Fehler beim Erstellen des Carts:",
              data.errors || data.data?.cartCreate?.userErrors
            );
            $this.discountLoading = false;
          }
        })
        .catch((error) => {
          console.error("Fehler beim Checkout-Vorgang:", error);
          $this.discountLoading = false;
        });

      // Funktion zum Anwenden des Rabattcodes und Weiterleiten
      function applyDiscountAndRedirect(cartId, checkoutUrl, discountCode) {
        const discountMutation = `
          mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
            cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
              cart {
                id
                checkoutUrl
                discountCodes {
                  code
                  applicable
                }
                cost {
                  totalAmount {
                    amount
                  }
                  subtotalAmount {
                    amount
                  }
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `;

        return fetch(
          "https://" + window.location.host + "/api/2023-07/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
            },
            body: JSON.stringify({
              query: discountMutation,
              variables: {
                cartId: cartId,
                discountCodes: [discountCode],
              },
            }),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.data?.cartDiscountCodesUpdate?.cart) {
              const cart = data.data.cartDiscountCodesUpdate.cart;
              const applicable = cart.discountCodes.some((dc) => dc.applicable);

              if (applicable) {
                // Statt manueller Berechnung den Cart neu laden und total_discount verwenden
                $this.refreshCartData().then(updatedCart => {
                  // Update der UI und des Zustands mit dem korrekten Rabattwert
                  $this.discount = updatedCart.total_discount;
                  $this.validDiscountCode = discountCode.trim().toUpperCase();
                  $this.codeStatus = "valid";

                  // Versandkosten basierend auf Schwelle neu berechnen (keine Annahme von kostenlosem Versand durch Code)
                  $this.hasFreeShipping();

                  // Cookies werden hier NICHT mehr gesetzt. Die Storefront-API
                  // prueft gegen einen Wegwerf-Cart und sagt damit nichts
                  // darueber aus, ob der Code am echten Warenkorb greift.
                  // Zustaendig ist syncDiscountCodeStateFromCart(): es schreibt
                  // das Cookie nur fuer den Code, den cart.discount_codes als
                  // applicable meldet, und loescht es sonst.

                  // UI-Elemente aktualisieren
                  var vdc = document.getElementById("cartDiscountCode");
                  vdc && (vdc.value = discountCode.trim().toUpperCase());

                  var vd = document.getElementById("cartDiscount");
                  vd && (vd.value = discountCode.trim().toUpperCase());

                  // Aktualisiere die Gesamtsumme mit Rabatt
                  // Verwende direkt den total_price aus updatedCart, der bereits den Rabatt berücksichtigt
                  $this.discountedTotal = updatedCart.total_price;
                  $this.total_price_after_discount = updatedCart.total_price;
                  // Wir setzen total_price auf den Wert vor Rabatt
                  $this.total_price = updatedCart.original_total_price || (updatedCart.total_price + updatedCart.total_discount);

                  // Prüfe Geschenkansprüche mit dem neuen Rabatt
                  setTimeout(() => {
                    // $this.checkGiftClaims();
                    $this.checkUpsells();
                  }, 100);
                });
              } else {
                // Rabattcode ist nicht anwendbar
                $this.codeStatus = "invalid";
                $this.discount = 0;
                $this.validDiscountCode = null;

                // Leere Eingabefelder
                var vdc = document.getElementById("cartDiscountCode");
                vdc && (vdc.value = "");

                var vd = document.getElementById("cartDiscount");
                vd && (vd.value = "");
              }

              // Zum Checkout weiterleiten
              // window.location.href = cart.checkoutUrl;
            } else {
              // Bei Fehlern trotzdem weiterleiten
              // window.location.href = checkoutUrl;
            }
            $this.discountLoading = false;
            $this.total_price_after_discount = $this.total_price - $this.discount;
            // window.checkFreeDiscountProducts();
            // $this.checkGiftClaims();
            // $this.checkUpsells();
          })
          .catch((error) => {
            console.error("Fehler beim Anwenden des Rabattcodes:", error);
            // Bei Fehler trotzdem zum Checkout weiterleiten
            window.location.href = checkoutUrl;
            $this.discountLoading = false;
          });
      }
    },
    updateUpsellProducts() {
      this.upsellProducts = [];
      if (this.upsells && this.upsells.length) {
        for (const upsell of this.upsells) {
          if (upsell.mandatory_products && upsell.mandatory_products.length) {
            const mandatoryProductIds = upsell.mandatory_products.map(
              (p) => p.id
            );
            const cartProductIds = this.items.map((item) => item.product_id);
            const mandatoryProductsInCart = mandatoryProductIds.filter((id) =>
              cartProductIds.includes(id)
            );
            if (mandatoryProductsInCart.length) {
              for (const upsellProduct of upsell.upsell_products) {
                if (
                  !this.items.find(
                    (item) => item.product_id == upsellProduct.id
                  )
                ) {
                  this.upsellProducts.push(upsellProduct);
                }
              }
            }
          }
        }
      }
    },

    // Funktion zum Aktualisieren der alternativen Produkte aus Metafeldern
    updateAlternativeProducts() {
      this.alternativeProductsToShow = [];

      if (
        !this.alternativeProducts ||
        !this.alternativeProducts.length ||
        !this.items ||
        !this.items.length
      ) {

        return;
    }

      // Sammle alle Produkt-IDs im Warenkorb
      const cartProductIds = this.items.map((item) => item.product_id);

      // Finde alternative Produkte für die Produkte im Warenkorb
      for (const altProduct of this.alternativeProducts) {

        // Prüfe, ob das Quellprodukt im Warenkorb ist
        if (cartProductIds.includes(altProduct.source_product_id)) {

          // Prüfe, ob das alternative Produkt bereits im Warenkorb ist
          if (!cartProductIds.includes(altProduct.id)) {

            // Prüfe, ob das alternative Produkt bereits in der Liste ist
            if (
              !this.alternativeProductsToShow.find(
                (p) => p.id === altProduct.id
              )
            ) {
              this.alternativeProductsToShow.push(altProduct);
            }
          } else {

          }
        } else {

        }
      }
    },

    // Entfernt den aktuell eingeloesten Rabattcode aus dem Warenkorb.
    // Hintergrund: /discount/NEUERCODE ersetzt einen bestehenden Code nur,
    // wenn beide derselben Rabattklasse angehoeren. Ein Versandkosten-Code
    // wird neben einem Prozent-Code stattdessen mit applicable:false angehaengt.
    // Damit ein neuer Code den alten immer ersetzt, wird der alte vorher
    // geloescht. Rueckgabe: true, wenn danach kein Code mehr aktiv ist.
    async clearActiveDiscountCode() {
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ discount: "" }),
        });
      } catch (error) {
        console.warn("[Cart] Rabattcode entfernen fehlgeschlagen:", error);
      }

      const after = await this.refreshCartData();
      const stillActive = _dsGetActiveCartCode(after);

      return !stillActive;
    },
    async validateDiscountCode(code) {
      if (!code || code.trim().length === 0) {
        return false;
      }

      try {
        // Set loading state
        this.discountLoading = true;
        // freeShippingFromDiscountCode wird nicht mehr hier gesetzt, sondern in
        // syncDiscountCodeStateFromCart() aus cart.discount_codes abgeleitet.

        // Direct approach: Use the /discount/ URL to apply the discount code
        // This is the simplest and most reliable way to apply a discount code
        const shopUrl = window.location.hostname;

        const normalizedCode = code.trim().toUpperCase();

        // Ein neuer Code soll den bisherigen immer ersetzen (dieser Shop
        // kombiniert keine Codes). Deshalb den bestehenden Code vorher
        // entfernen - sonst haengt Shopify einen Versandkosten-Code nur
        // zusaetzlich an und markiert ihn als nicht anwendbar.
        const cartBefore = await this.refreshCartData();
        const previousCode = _dsGetActiveCartCode(cartBefore);
        if (previousCode && previousCode !== normalizedCode) {
          await this.clearActiveDiscountCode();
        }

        // Code auf den Warenkorb anwenden.
        await fetch(`https://${shopUrl}/discount/${code}`, {
          method: "GET",
          mode: "no-cors", // Important as this is a cross-origin request
          credentials: "include", // Send cookies so the discount code applies to the session
        });

        // Short pause to ensure the discount code has been applied
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Ergebnis am Warenkorb ablesen. cart.discount_codes sagt direkt, ob
        // der Code greift - unabhängig davon, ob er den Warenwert senkt
        // (Prozent-Code) oder nur den Versand (Gratisversand-Code).
        const cartAfter = await this.refreshCartData();
        const activeCode = _dsGetActiveCartCode(cartAfter);

        this.discount_codes = cartAfter.discount_codes || [];

        if (activeCode === normalizedCode) {
          this.total_discount = cartAfter.total_discount;
          this.total_price_after_discount = cartAfter.total_price;

          this.codeStatus = "valid";
          this.codeErrorReason = null;
          this.validDiscountCode = normalizedCode;
          this.discountLoading = false;

          return true;
        }

        // Der Code greift nicht. Zwei Faelle unterscheiden, damit die Meldung
        // im Formular stimmt:
        //   already_active  - der vorherige Code liess sich nicht entfernen und
        //                     blockiert weiterhin (Ersetzen fehlgeschlagen)
        //   not_applicable  - der Code gilt fuer diesen Warenkorb nicht
        this.codeStatus = "invalid";
        this.codeErrorReason = activeCode ? "already_active" : "not_applicable";
        this.validDiscountCode = activeCode;
        this.discountLoading = false;
        return false;
      } catch (error) {
        console.error("Error validating discount code:", error);
        this.codeStatus = "invalid";
        this.discountLoading = false;
        return false;
      }
    },

    // Helper function to refresh cart data
    async refreshCartData() {
      try {
        const response = await fetch("/cart.js");
        if (!response.ok) {
          throw new Error(
            `Failed to fetch cart: ${response.status} ${response.statusText}`
          );
        }
        return await response.json();
      } catch (error) {
        console.error("Error fetching cart data:", error);
        throw error;
      }
    },
    
    // Uebertraegt eine /cart.js-Antwort in den Alpine-Zustand.
    // EINZIGE Stelle, an der Warenkorb-Preise und Item-Listen gesetzt werden:
    // refreshCart() ruft sie nach dem Fetch auf, initialize() mit der Antwort,
    // die beim Seitenaufbau schon geladen wurde. Bitte keine zweite
    // Preisberechnung daneben aufbauen - genau daraus entstand der nach einem
    // Reload doppelt abgezogene Rabatt: initialize() setzte total_price auf
    // cart.total_price (also NACH Rabatt), waehrend das Template
    // total_price - discount anzeigt.
    applyCartData(cartData) {
      if (!cartData) return;

      // Aktualisiere den Alpine.js-Zustand mit den Daten direkt aus der Shopify Cart API
      this.cart = cartData;
      this.items = cartData.items || [];
      this.itemCount = cartData.item_count || 0;
      
      // Preisberechnungen direkt aus der Cart API
      // Shopify liefert Preise in Cent, daher keine Umrechnung notwendig
      
      // WICHTIG: In der UI wird der Preis als total_price-discount angezeigt
      // Daher müssen wir total_price auf den Preis VOR Rabatt setzen
      // und discount auf den Rabattbetrag
      
      // Rabatt-Informationen aus der Cart API
      this.discount = cartData.total_discount || 0;

      // Rabattanwendungen aus der Cart API laden
      this.discount_applications = this.collectDiscountApplications(cartData);

      
      // Original-Gesamtpreis (vor Rabatt) aus der Cart API
      // Wenn original_total_price nicht verfügbar ist, berechnen wir ihn aus total_price + total_discount
      this.original_total_price = cartData.original_total_price || (cartData.total_price + cartData.total_discount) || 0;
      
      // Setze total_price auf den Preis VOR Rabatt (original_total_price)
      // Dies ist wichtig, da in der UI total_price-discount angezeigt wird
      this.total_price = this.original_total_price;
      
      // Der Preis nach Rabatt ist der tatsächliche Preis aus der Cart API
      this.total_price_after_discount = cartData.total_price || 0;
      
      // Setze discountedTotal auf den tatsächlichen Preis nach Rabatt
      this.discountedTotal = this.total_price_after_discount;

      // Rabattcode-Status aus dem echten Warenkorb ableiten, damit das
      // Formular oben und die Rabattzeile unten nicht auseinanderlaufen.
      this.syncDiscountCodeStateFromCart(cartData);

      
      // Teile die Items in bezahlte und Gratis-Items auf
      // Ein Artikel gilt als Gratis, wenn sowohl final_price als auch price 0 sind
      this.itemsPaid = this.items.filter(item => item.price > 0 || item.final_price > 0);
      this.itemsFree = this.items.filter(item => item.price === 0 && item.final_price === 0);
      
      // Berechne den Gesamtpreis ohne Rabatt (Vergleichspreis)
      // Wir verwenden die Compare-at-Preise der Produkte, wenn verfügbar
      let totalComparePrice = 0;
      for (const item of this.items) {
        // Hole den Vergleichspreis für das Produkt
        let compareAtPrice = this.getCompareAtPrice(item.variant_id);
        // Wenn kein Vergleichspreis vorhanden ist, verwende den regulären Preis
        if (!compareAtPrice) compareAtPrice = item.price;
        if (compareAtPrice) {
          totalComparePrice += compareAtPrice * item.quantity;
        }
      }
      
      // Setze den Gesamtpreis ohne Rabatt
      // Verwende den größeren Wert aus totalComparePrice und original_total_price
      this.total_price_without_discount = Math.max(totalComparePrice, this.original_total_price);
      
      // Einsparungen berechnen (Differenz zwischen Gesamtpreis ohne Rabatt und tatsächlichem Preis nach Rabatt)
      // Wichtig: In der UI wird total_price-discount angezeigt, daher müssen wir die Einsparungen entsprechend berechnen
      this.savings = this.total_price_without_discount - this.total_price_after_discount;
      
      // // Prüfe die Geschenk-Berechtigung basierend auf dem aktuellen Warenkorbwert
      // if (window.updateGiftEligibility) {
      //   window.updateGiftEligibility();
      // }
      
      
      // Hier stand eine zweite Versandkosten-Berechnung. Sie war doppelt
      // fehlerhaft: free_from ist bereits ein Cent-Wert und wurde nochmals
      // mit 100 multipliziert, und freeShipping.shipping_cost existiert nicht
      // (die Section liefert shipping_costs). Vor allem lief sie NACH
      // syncDiscountCodeStateFromCart() und setzte dessen korrekt erkanntes
      // freeShippingFromDiscountCode wieder auf false - ein Gratisversand-Code
      // konnte sich deshalb nie auf die Anzeige auswirken.
      // Versandkosten kommen jetzt ausschliesslich aus shippingAmount().
    },

    // Aktualisiert den Warenkorb-Zustand nach einer Änderung
    async refreshCart() {
      try {
        // Hole die aktuellen Warenkorb-Daten
        const cartData = await this.refreshCartData();
        
        // Zustand und Preise zentral setzen - siehe applyCartData().
        this.applyCartData(cartData);

        return cartData;
      } catch (error) {
        console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
        return null;
      }
    },

       // Function to handle discount code submission
       async handleDiscountSubmitAfterGiftProduct(code) {
        if (!code || this.discountLoading) return;
  
        this.discountLoading = true;
  
        try {
          // Normalize the code
          const normalizedCode = code.trim().toUpperCase();
  
          // Validate the discount code
          const isValid = await this.validateDiscountCode(normalizedCode);
  
          if (isValid) {
            this.codeStatus = "valid";
            this.validDiscountCode = normalizedCode;
            this.discountCodeInput = normalizedCode;
  
            // Trigger any additional actions needed after successful discount application
            if (typeof window.checkDiscountGifts === "function") {
              window.checkDiscountGifts.call(this, normalizedCode);
            }
          } else {
            this.codeStatus = "invalid";
            this.validDiscountCode = null;
          }
        } catch (error) {
          console.error("Error in handleDiscountSubmit:", error);
          this.codeStatus = "invalid";
        } finally {
          this.discountLoading = false;
        }
       },
  };
  
  // Store the instance globally when initialized
  window.dsCartDrawerInstance = instance;
  
  // Return the instance for Alpine.js
  return instance;
};

// Weiterleitung zum Checkout aus dem Warenkorb-Drawer.
// Haengt ?discount= nur an, wenn der Warenkorb den Code als anwendbar meldet
// (validDiscountCode kommt aus syncDiscountCodeStateFromCart). Frueher wurde
// hier das Cookie direkt ausgelesen - dadurch kam ein im Checkout entfernter
// Code beim naechsten Klick wieder zurueck, obwohl er im Warenkorb nicht mehr
// aktiv war.
window.dsGoToCheckout = function () {
  // Bevorzugt den von Alpine verwalteten Zustand lesen, damit garantiert der
  // aktuelle Wert genutzt wird und nicht eine veraltete Referenz.
  let state = window.dsCartDrawerInstance || null;
  const drawer = document.querySelector(".ds-cart-drawer");
  if (drawer && window.Alpine && window.Alpine.$data) {
    try {
      state = window.Alpine.$data(drawer) || state;
    } catch (e) {
      /* Fallback bleibt die globale Instanz */
    }
  }

  // Genau ein Code - dieser Shop kombiniert keine Rabattcodes.
  const code = (state && state.validDiscountCode) || "";

  if (code) {
    window.location.href = "/checkout?discount=" + encodeURIComponent(code);
    return;
  }

  const form = document.getElementById("checkout-form");
  if (form) {
    form.submit();
  } else {
    window.location.href = "/checkout";
  }
};

// Create a global addGiftProduct function that delegates to the component instance
window.addGiftProduct = function(giftProduct) {
  if (window.dsCartDrawerInstance && typeof window.dsCartDrawerInstance.addGiftProduct === 'function') {
    return window.dsCartDrawerInstance.addGiftProduct(giftProduct);
  } else {
    console.error('dsCartDrawerInstance is not initialized or addGiftProduct method is not available');
    return Promise.reject('Cart drawer not initialized');
  }
};

function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

// Event-Listener für Rabattcode-Validierung - Optimierte Version
window.addEventListener('validate-discount-code', function(event) {
  if (event.detail && event.detail.code) {
    
    // Suche nach der Alpine.js-Komponente
    const cartComponents = document.querySelectorAll('[x-data]');
    let found = false;
    
    cartComponents.forEach((component, index) => {
      if (found) return;
      if (window.Alpine) {
        const alpineInstance = window.Alpine.$data(component);
        
        if (alpineInstance && typeof alpineInstance.validateDiscountCode === 'function') {
          found = true; // Markiere als gefunden, bevor wir mit der Validierung beginnen
          
          // Normalisiere den Code
          const normalizedCode = event.detail.code.trim().toUpperCase();
          
          // Setze den Ladeindikator
          alpineInstance.discountLoading = true;
          
          // Optimierte Sequenz: Validiere den Code und führe alle Aktionen in einer Kette aus
          alpineInstance.validateDiscountCode(normalizedCode)
            .then(isValid => {
              if (isValid) {
                // Setze die Alpine-Variablen
                alpineInstance.codeStatus = "valid";
                alpineInstance.validDiscountCode = normalizedCode;
                alpineInstance.discountCodeInput = normalizedCode;

                // Setze Cookie für den Rabattcode
                document.cookie = `discount_code=${normalizedCode}; path=/; max-age=3600`;
                document.cookie = `discount_code_referrer=${normalizedCode}; path=/; max-age=3600`;

                // Einmalige Aktualisierung des Warenkorbs mit allen notwendigen Schritten

                return fetch('/cart.js')
                  .then(response => response.json())
                  .then(cart => {
                    // 1. Aktualisiere den Warenkorb
                    alpineInstance.updateCart(cart);

                    // 2. Aktualisiere die Gesamtsumme mit Rabatt
                    alpineInstance.discountedTotal = cart.total_price;
                    alpineInstance.total_price_after_discount = cart.total_price;

                    return Promise.resolve();
                  });
              } else {
                alpineInstance.codeStatus = "invalid";
                alpineInstance.validDiscountCode = null;
                return Promise.resolve();
              }
            })
            .catch(error => {
              console.error('Fehler bei der Validierung:', error);
              alpineInstance.codeStatus = "invalid";
              alpineInstance.validDiscountCode = null;
            })
            .finally(() => {
              // Beende den Ladevorgang
              alpineInstance.discountLoading = false;
            });
        }
      }
    });
    
  }
});

// AS BE-0061 START
document.addEventListener("DOMContentLoaded", function () {
  try {
    as_be_0061_copyLogic();
  } catch (error) {
    // Error in AS BE-0061
  }
});
function as_be_0061_copyLogic() {
  document.querySelectorAll(".as-be-0061-copyBtn").forEach((button) => {
    button.addEventListener("click", function () {
      const parent = button.closest(".be-0061-copy");
      const img = parent.querySelector(".be-0061-copy-svg");
      const copyText = parent.querySelector(".be-0061-copyBtn");
      const copiedMessage = parent.querySelector(".be-0061-copiedBtn");

      navigator.clipboard
        .writeText(copyText.textContent)
        .then(() => {
          img.style.display = "none";
          copyText.style.display = "none";
          copiedMessage.style.display = "flex";
          setTimeout(() => {
            copiedMessage.style.display = "none";
            img.style.display = "flex";
            copyText.style.display = "flex";
          }, 2000);
        })
        .catch((err) => {
          alert("Kopieren fehlgeschlagen: " + err);
        });
    });
  });
}
// AS BE-0061 END
